(function () {
  'use strict';

  var root = document.getElementById('DdeyReadinessAdvisor');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var form = document.getElementById('DdeyAdvisorForm');
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
  var progress = Array.prototype.slice.call(root.querySelectorAll('[data-progress-step]'));
  var nextButton = document.getElementById('DraNext');
  var backButton = document.getElementById('DraBack');
  var status = document.getElementById('DraFormStatus');
  var results = document.getElementById('DraResults');
  var currentStep = 0;
  var activePackageItems = [];
  var activeContactOpening = [];
  var activeContactClosing = [];
  var activeBriefId = '';
  var activeProfile = null;
  var activeCompliance = null;
  var activeWaiverSelectionKey = '';
  var conciergeHistory = [];
  var conciergeBusy = false;
  var bridgeSession = null;
  var bridgeSessionPromise = null;
  var contactForm = document.getElementById('DdeyAdvisorContact');
  var planningEngine = window.DdeyAdvisorEngine;
  var DISCLAIMER_VERSION = '2026-08-28-v1';
  var DISCLAIMER_TEXT = "I understand my selected package is below D-Dey's recommendation and is not represented as satisfying flag-state, USCG, MCA, class, insurer, commercial, or operating requirements. I authorize checkout and accept responsibility for compliance review.";

  var briefingModal = document.getElementById('DraBriefingModal');
  var briefingDialog = briefingModal && briefingModal.querySelector('.dra__briefing-dialog');
  var briefingVideo = document.getElementById('DraBriefingVideo');
  var briefingOpeners = Array.prototype.slice.call(root.querySelectorAll('[data-dra-briefing-open]'));
  var briefingClosers = briefingModal ? Array.prototype.slice.call(briefingModal.querySelectorAll('[data-dra-briefing-close]')) : [];
  var briefingReturnFocus = null;

  function closeBriefing() {
    if (!briefingModal || briefingModal.hidden) return;
    if (briefingVideo) briefingVideo.pause();
    briefingModal.hidden = true;
    document.documentElement.classList.remove('dra-briefing-open');
    briefingOpeners.forEach(function (opener) { opener.setAttribute('aria-expanded', 'false'); });
    if (briefingReturnFocus && typeof briefingReturnFocus.focus === 'function') briefingReturnFocus.focus();
  }

  function openBriefing(event) {
    if (!briefingModal || !briefingDialog) return;
    briefingReturnFocus = event && event.currentTarget ? event.currentTarget : document.activeElement;
    briefingModal.hidden = false;
    document.documentElement.classList.add('dra-briefing-open');
    briefingOpeners.forEach(function (opener) { opener.setAttribute('aria-expanded', 'true'); });
    briefingDialog.focus();
  }

  if (briefingModal && briefingDialog && briefingOpeners.length) {
    briefingOpeners.forEach(function (opener) { opener.addEventListener('click', openBriefing); });
    briefingClosers.forEach(function (closer) { closer.addEventListener('click', closeBriefing); });
    document.addEventListener('keydown', function (event) {
      if (briefingModal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeBriefing();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(briefingDialog.querySelectorAll('button, a[href], video, [tabindex]:not([tabindex="-1"])'))
        .filter(function (node) { return !node.disabled && node.offsetParent !== null; });
      if (!focusable.length) {
        event.preventDefault();
        briefingDialog.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (document.activeElement === briefingDialog) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  if (!planningEngine) {
    nextButton.disabled = true;
    status.textContent = 'The recommendation engine is temporarily unavailable. Please contact D-Dey for a vessel review.';
    return;
  }

  var labels = {
    operation: {
      private: 'Private pleasure',
      charter: 'Charter / passenger',
      fishing: 'Commercial fishing',
      workboat: 'Workboat / commercial'
    },
    operatingWaters: {
      international: 'International / multiple jurisdictions',
      us: 'United States waters',
      uk: 'United Kingdom waters',
      mediterranean: 'Mediterranean / European waters',
      caribbean: 'Caribbean / Bahamas',
      other: 'Other operating area'
    },
    vesselType: {
      'motor-yacht': 'Motor yacht',
      'sailing-yacht': 'Sailing yacht',
      sportfishing: 'Sportfishing vessel',
      skiff: 'Skiff / bay boat',
      dayboat: 'Center console / dayboat',
      'work-vessel': 'Work or support vessel',
      other: 'Other vessel'
    },
    distance: {
      '3': 'Up to 3 nm',
      '20': '3–20 nm',
      '60': '20–60 nm',
      '150': '60–150 nm',
      '175': '150–175 nm',
      '176': '175+ nm / unrestricted'
    },
    duration: {
      '0': 'Day trips',
      '1': '1–2 days',
      '3': '3–7 days',
      '8': '8–14 days',
      '15': '15+ days'
    },
    careDelay: {
      '1': 'Usually within 1 hour',
      '4': 'About 1–4 hours',
      '12': 'About 4–12 hours',
      '13': 'More than 12 hours'
    },
    training: {
      none: 'No current formal training',
      basic: 'CPR / basic first aid',
      marine: 'Marine first aid / ELS-M',
      advanced: 'Advanced medical professional'
    },
    storage: {
      flexible: 'Either case configuration',
      large: 'Dedicated space for a larger primary case',
      compact: 'Limited space; smaller cases preferred'
    },
    kitTransfer: {
      none: 'Equipment stays aboard the main vessel',
      occasional: 'Occasionally moved to auxiliary craft',
      routine: 'Routinely deployed with auxiliary craft'
    },
    complianceIntent: {
      readiness: 'Practical readiness',
      guided: 'Compliance-conscious planning',
      agency: 'Agency-specific custom order'
    },
    mcaCategory: {
      A: 'Category A — unrestricted',
      B: 'Category B — generally within 150 nm',
      C: 'Category C — harbour / very close to shore',
      unknown: 'Not sure — D-Dey determination required'
    }
  };

  var knownKitProfiles = {
    'ruck-60-advanced': {
      rank: 1300,
      capabilities: { bvm: false, oxygen: false, aed: false, monitoring: false },
      summary: 'The live Adventurer inventory is D-Dey’s smallest EMS platform: a waterproof 11.14 × 6.86 × 3.88-inch quick-grab system covering single-incident trauma and bleeding control, a basic airway adjunct, common medications, burns, wounds, and first aid. It does not list a BVM, onboard oxygen, AED, pulse oximeter, or advanced monitoring, so the advisor does not treat it as a substitute for a larger primary system when broader capability is indicated.'
    },
    'ems-1400-medical-kit': {
      rank: 1400,
      capabilities: { bvm: false, oxygen: false, aed: false, monitoring: false },
      summary: 'The EMS-1400 is the compact EMS base for small private-vessel and near-shore profiles. Its published inventory covers trauma, pocket-mask airway support, pulse oximetry, burns, wounds, and common first-aid needs; it does not list a BVM, onboard oxygen, or AED.'
    },
    'ems-1500-medical-kit': {
      rank: 1500,
      capabilities: { bvm: true, oxygen: false, aed: false, monitoring: false },
      summary: 'The EMS-1500 adds a BVM and materially deeper trauma, airway, burn, wound, and immobilization reserves. Its published inventory does not list onboard oxygen, an AED, blood-pressure monitoring, or blood-glucose monitoring.'
    },
    'ems-1550-medical-kit': {
      rank: 1550,
      capabilities: { bvm: true, oxygen: true, aed: false, monitoring: true },
      summary: 'The EMS-1550 is the offshore-capability step: its published inventory adds oxygen delivery, blood-pressure and blood-glucose monitoring, a BVM, and broader wound-management capability to an expanded trauma and medical platform.'
    },
    'ems-1600-medical-kit': {
      rank: 1600,
      capabilities: { bvm: true, oxygen: true, aed: true, monitoring: true },
      summary: 'The EMS-1600 is D-Dey’s largest published EMS platform and is described for 10+ patients. Its published inventory includes an AED, oxygen, BVM, blood-pressure and blood-glucose monitoring, advanced trauma, wound, and environmental support.'
    }
  };

  var knownGuardianProfiles = {
    'open-water-guardian-survival-series-kit-copy': {
      tier: 1,
      capabilities: { hydration: true, food: true, medical: true, signaling: true, communications: false, locator: true, power: true },
      summary: 'The verified Coastal inventory combines emergency hydration and desalination, rations, trauma and first aid, visual signaling, shelter, repair, navigation, power, environmental protection, and an included PLB in a compact waterproof case. VHF is offered as an optional package.'
    },
    'open-water-kit-guardian-survival-series': {
      tier: 2,
      capabilities: { hydration: true, food: true, medical: true, signaling: true, communications: true, locator: true, power: true },
      summary: 'The published Open Water platform is the higher-capability Guardian system for delayed rescue: hydration, rations, trauma care, SOLAS signaling, VHF communication, PLB location, navigation, repair, and solar-supported power in a watertight case.'
    }
  };

  function dataFor(selector) {
    var node = root.querySelector(selector);
    return node ? {
      title: node.dataset.title,
      price: node.dataset.price,
      priceCents: Number(node.dataset.priceCents) || 0,
      url: node.dataset.url,
      variantId: node.dataset.variantId || '',
      image: node.dataset.image || ''
    } : {};
  }

  function inferredCapabilities(text) {
    return {
      bvm: /\bbvm\b|bag valve mask|bag-valve-mask/i.test(text),
      oxygen: /oxygen delivery|oxygen system|oxygen cylinder|medical oxygen/i.test(text),
      aed: /\baed\b|automated external defibrillator/i.test(text),
      monitoring: /blood pressure|blood glucose|glucometer/i.test(text)
    };
  }

  function capabilitySummary(capabilities) {
    var list = [];
    if (capabilities.bvm) list.push('BVM airway support');
    if (capabilities.oxygen) list.push('onboard oxygen');
    if (capabilities.monitoring) list.push('advanced monitoring');
    if (capabilities.aed) list.push('AED capability');
    return list.length ? list.join(', ') : 'core trauma, medical, and first-aid capability';
  }

  function productFromNode(node) {
    var handle = node.dataset.handle || '';
    var known = knownKitProfiles[handle];
    var description = node.dataset.description || '';
    var modelMatch = handle.match(/ems-(\d+)/i);
    var priceCents = Number(node.dataset.priceCents) || 0;
    var rank = (known && known.rank) || (modelMatch ? Number(modelMatch[1]) : 0) || priceCents || 999999999;
    var capabilities = known ? known.capabilities : inferredCapabilities((node.dataset.title || '') + ' ' + description + ' ' + (node.dataset.tags || ''));
    var summary = node.dataset.advisorSummary || (known && known.summary);
    var capacity = planningEngine.publishedCapacity((node.dataset.tags || '') + ' ' + description + ' ' + (node.dataset.title || ''));
    if (!summary) {
      summary = 'A current D-Dey EMS option whose published description indicates ' + capabilitySummary(capabilities) + '. D-Dey confirms inventory depth and any advanced-capability gaps during the package review.';
    }
    return {
      handle: handle,
      title: node.dataset.title,
      price: node.dataset.price,
      priceCents: priceCents,
      url: node.dataset.url,
      variantId: node.dataset.variantId || '',
      image: node.dataset.image || '',
      rank: rank,
      capabilities: capabilities,
      capacity: capacity,
      summary: summary
    };
  }

  var catalog = Array.prototype.slice.call(root.querySelectorAll('[data-kit="ems"]'))
    .map(productFromNode)
    .sort(function (a, b) { return a.rank - b.rank || a.priceCents - b.priceCents; });

  function guardianCapabilities(text) {
    return {
      hydration: /drinking water|desalination|desalinator|water production/i.test(text),
      food: /food ration|survival ration|sustenance/i.test(text),
      medical: /trauma|first aid|medical care/i.test(text),
      signaling: /signal|flare|strobe|dye marker/i.test(text),
      communications: /vhf marine radio|vhf radio included|integrated communication/i.test(text),
      locator: /personal locator beacon|\bplb\b|\bepirb\b/i.test(text),
      power: /solar|battery pack|charging/i.test(text)
    };
  }

  function guardianCapabilitySummary(capabilities) {
    var list = [];
    if (capabilities.hydration) list.push('hydration');
    if (capabilities.food) list.push('rations');
    if (capabilities.medical) list.push('medical support');
    if (capabilities.signaling) list.push('signaling');
    if (capabilities.communications) list.push('communications');
    if (capabilities.locator) list.push('location');
    if (capabilities.power) list.push('emergency power');
    return list.length ? list.join(', ') : 'core maritime survival capability';
  }

  function guardianTierFromNode(node, known, capabilities) {
    if (known && typeof known.tier === 'number') return known.tier;
    var tags = String(node.dataset.tags || '');
    var explicit = tags.match(/advisor tier\s*:\s*(compact|inshore|coastal|open[ -]?water|offshore|ocean|expedition|[0-2])/i);
    if (explicit) {
      var value = explicit[1].toLowerCase();
      if (value === '0' || /compact|inshore/.test(value)) return 0;
      if (value === '1' || value === 'coastal') return 1;
      return 2;
    }

    var title = String(node.dataset.title || '').toLowerCase();
    if (/compact|small(?:er)?|mini|tender|inshore|near[ -]?shore|day/.test(title)) return 0;
    if (/coastal/.test(title)) return 1;
    if (/open[ -]?water|offshore|ocean|expedition|extended/.test(title)) return 2;
    if (capabilities.communications && capabilities.locator) return 2;
    if (capabilities.hydration && capabilities.medical && capabilities.signaling) return 1;
    return 0;
  }

  function sortGuardianCatalog(a, b) {
    return a.tier - b.tier || a.priceCents - b.priceCents || a.title.localeCompare(b.title);
  }

  function guardianFromNode(node) {
    var handle = node.dataset.handle || '';
    var known = knownGuardianProfiles[handle];
    var description = node.dataset.description || '';
    var priceCents = Number(node.dataset.priceCents) || 0;
    var capabilities = known ? known.capabilities : guardianCapabilities((node.dataset.title || '') + ' ' + description);
    var tier = guardianTierFromNode(node, known, capabilities);
    var summary = node.dataset.advisorSummary || (known && known.summary);
    if (!summary) {
      summary = 'A current Guardian Survival Series option whose published description indicates ' + guardianCapabilitySummary(capabilities) + '. D-Dey confirms the completed contents and vessel-specific stowage during package review.';
    }
    return {
      handle: handle,
      title: node.dataset.title,
      price: node.dataset.price,
      priceCents: priceCents,
      url: node.dataset.url,
      variantId: node.dataset.variantId || '',
      image: node.dataset.image || '',
      tier: tier,
      capabilities: capabilities,
      summary: summary
    };
  }

  var guardianCatalog = Array.prototype.slice.call(root.querySelectorAll('[data-survival-kit="guardian"]'))
    .map(guardianFromNode)
    .sort(sortGuardianCatalog);
  var addons = {
    rx: dataFor('[data-addon="rx"]'),
    support: dataFor('[data-addon="support"]'),
    aed: dataFor('[data-addon="aed"]'),
    oxygen: dataFor('[data-addon="oxygen"]'),
    iv: dataFor('[data-addon="iv"]'),
    training: dataFor('[data-addon="training"]'),
    airway: {},
    monitoring: {}
  };

  function advisorRoleFor(node) {
    var tags = String(node.dataset.tags || '');
    var text = ((node.dataset.title || '') + ' ' + tags + ' ' + (node.dataset.description || '')).toLowerCase();
    var explicit = tags.match(/advisor role\s*:\s*(ems|guardian|aed|oxygen|iv|medication|support|training|airway|monitoring)/i);
    if (explicit) return explicit[1].toLowerCase();
    if (/emergency medical system|\bems[-\s]/i.test(text)) return 'ems';
    if (/guardian survival|survival series/i.test(text)) return 'guardian';
    if (/\b(aed|defibrillator|defibtech)\b/i.test(text)) return 'aed';
    if (/\b(oxygen|o2 cylinder|o2 regulator)\b/i.test(text)) return 'oxygen';
    if (/\b(iv|intravenous|fluid administration|giving set|ringer'?s lactate)\b/i.test(text)) return 'iv';
    if (/\b(bvm|bag valve mask|bag-valve-mask|airway module|resuscitation module)\b/i.test(text)) return 'airway';
    if (/\b(monitoring module|patient monitor|blood pressure|blood glucose|glucometer)\b/i.test(text)) return 'monitoring';
    if (/\b(rx|prescription|medication module|medicine module)\b/i.test(text)) return 'medication';
    if (/d-dey 365|medical support membership|24\/7 medical support/i.test(text)) return 'support';
    if (/\b(els-m|els m|emergency life saver|marine medical training|online course)\b/i.test(text)) return 'training';
    return 'unclassified';
  }

  function mergeAdvisorProduct(node) {
    var handle = node.dataset.handle || '';
    if (!handle) return;
    var role = advisorRoleFor(node);
    var tags = String(node.dataset.tags || '');
    var preferred = /(^|\|)advisor preferred(\||$)/i.test(tags);
    if (role === 'ems') {
      if (!catalog.some(function (item) { return item.handle === handle; })) {
        catalog.push(productFromNode(node));
        catalog.sort(function (a, b) { return a.rank - b.rank || a.priceCents - b.priceCents; });
      }
      return;
    }
    if (role === 'guardian') {
      if (!guardianCatalog.some(function (item) { return item.handle === handle; })) {
        guardianCatalog.push(guardianFromNode(node));
        guardianCatalog.sort(sortGuardianCatalog);
      }
      return;
    }
    var addonRole = role === 'medication' ? 'rx' : role;
    if (['aed', 'oxygen', 'iv', 'rx', 'support', 'training', 'airway', 'monitoring'].indexOf(addonRole) !== -1) {
      var discovered = {
        title: node.dataset.title,
        price: node.dataset.price,
        priceCents: Number(node.dataset.priceCents) || 0,
        url: node.dataset.url,
        variantId: node.dataset.variantId || '',
        image: node.dataset.image || ''
      };
      if (preferred || !addons[addonRole] || !addons[addonRole].title) addons[addonRole] = discovered;
    }
  }

  Array.prototype.slice.call(root.querySelectorAll('[data-advisor-product="true"]')).forEach(mergeAdvisorProduct);

  if (!catalog.length) {
    nextButton.disabled = true;
    status.textContent = 'The EMS catalog is temporarily unavailable. Please contact D-Dey for a recommendation.';
    return;
  }

  function setStep(index) {
    currentStep = Math.max(0, Math.min(index, steps.length - 1));
    steps.forEach(function (step, i) {
      var active = i === currentStep;
      step.hidden = !active;
      step.classList.toggle('is-active', active);
    });
    progress.forEach(function (item, i) {
      item.classList.toggle('is-active', i === currentStep);
      item.classList.toggle('is-complete', i < currentStep);
      item.disabled = i > currentStep;
      if (i === currentStep) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });
    backButton.hidden = currentStep === 0;
    nextButton.innerHTML = currentStep === steps.length - 1
      ? 'Get my D-Dey recommendation <span aria-hidden="true">→</span>'
      : 'Continue <span aria-hidden="true">→</span>';
    status.textContent = '';
    var heading = steps[currentStep].querySelector('h3');
    if (heading) heading.focus({ preventScroll: true });
  }

  function validateStep() {
    var fields = Array.prototype.slice.call(steps[currentStep].querySelectorAll('input, select'));
    var invalid = fields.find(function (field) {
      if (field.type === 'radio') {
        return field.required && !steps[currentStep].querySelector('input[name="' + field.name + '"]:checked');
      }
      return !field.checkValidity();
    });
    if (!invalid) return true;
    status.textContent = invalid.name === 'acknowledgement'
      ? 'Please confirm the planning disclaimer to continue.'
      : 'Please complete the highlighted field.';
    invalid.focus();
    return false;
  }

  function formValue(name) {
    var checked = form.querySelector('[name="' + name + '"]:checked');
    var field = checked || form.elements.namedItem(name);
    return field && typeof field.value !== 'undefined' ? field.value : '';
  }

  function normalizedFlagState(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z]/g, '');
  }

  function isMcaFlagState(value) {
    return ['unitedkingdom', 'unitedkingdomofgreatbritainandnorthernireland', 'greatbritain', 'uk'].indexOf(normalizedFlagState(value)) !== -1;
  }

  function syncMcaCategoryField() {
    var field = document.getElementById('DraMcaCategoryField');
    var select = form.elements.mcaCategory;
    if (!field || !select) return;
    var applies = isMcaFlagState(formValue('flagState'));
    field.hidden = !applies;
    select.disabled = !applies;
    select.required = applies;
    if (!applies) select.value = '';
  }

  function collectProfile() {
    var rawLength = Math.max(0, Number(formValue('length')) || 0);
    var unit = formValue('lengthUnit');
    var lengthFeet = unit === 'm' ? rawLength * 3.28084 : rawLength;
    var riskFields = Array.prototype.slice.call(form.querySelectorAll('input[name="risk"]:checked'));
    var passengers = Math.max(0, Math.round(Number(formValue('passengers')) || 0));
    var crew = Math.max(0, Math.round(Number(formValue('crew')) || 0));
    var decks = Math.max(1, Math.round(Number(formValue('decks')) || 1));
    var auxiliaryCraft = Math.max(0, Math.min(20, Math.round(Number(formValue('auxiliaryCraft')) || 0)));
    var auxiliaryPeople = Math.max(0, Math.min(passengers + crew, Math.round(Number(formValue('auxiliaryPeople')) || 0)));
    var kitTransfer = formValue('kitTransfer') || 'none';
    if (auxiliaryCraft > 0 && kitTransfer === 'none') kitTransfer = 'occasional';
    if (kitTransfer !== 'none' && auxiliaryCraft === 0) auxiliaryCraft = 1;
    var flagState = String(formValue('flagState') || '').trim();
    var normalizedFlag = normalizedFlagState(flagState);
    var redEnsignFlags = [
      'bermuda', 'britishvirginislands', 'caymanislands', 'gibraltar', 'isleofman',
      'anguilla', 'falklandislands', 'guernsey', 'jersey', 'montserrat',
      'sthelena', 'turksandcaicosislands'
    ];
    var flag = 'other';
    if (['unitedstates', 'unitedstatesofamerica', 'usa', 'us'].indexOf(normalizedFlag) !== -1) flag = 'us';
    else if (['unitedkingdom', 'greatbritain', 'uk'].indexOf(normalizedFlag) !== -1) flag = 'uk';
    else if (redEnsignFlags.indexOf(normalizedFlag) !== -1) flag = 'red-ensign';
    else if (normalizedFlag === 'marshallislands' || normalizedFlag === 'republicofthemarshallislands') flag = 'marshall';
    else if (normalizedFlag === 'malta') flag = 'malta';
    var risks = riskFields.map(function (field) { return field.value; });
    if ((kitTransfer !== 'none' || auxiliaryCraft > 0) && risks.indexOf('tenders') === -1) risks.push('tenders');
    return {
      operation: formValue('operation'),
      flag: flag,
      flagState: flagState,
      mcaCategory: flag === 'uk' ? formValue('mcaCategory') : '',
      operatingWaters: formValue('operatingWaters'),
      length: rawLength,
      lengthUnit: unit,
      lengthFeet: lengthFeet,
      vesselType: formValue('vesselType'),
      accommodation: formValue('accommodation'),
      decks: decks,
      storage: formValue('storage'),
      kitTransfer: kitTransfer,
      auxiliaryCraft: auxiliaryCraft,
      auxiliaryPeople: auxiliaryPeople,
      distance: Number(formValue('distance')),
      duration: Number(formValue('duration')),
      careDelay: Number(formValue('careDelay')),
      passengers: passengers,
      crew: crew,
      total: passengers + crew,
      training: formValue('training'),
      complianceIntent: formValue('complianceIntent') || 'readiness',
      risks: risks
    };
  }

  function isSmallCraftDayProfile(profile) {
    return planningEngine.isCompactDayCraft(profile);
  }

  function isAdventurerPrimaryProfile(profile) {
    return isSmallCraftDayProfile(profile) &&
      profile.total <= 6 &&
      profile.risks.indexOf('children') === -1;
  }

  function productAtOrAboveRank(targetRank, people) {
    var product = catalog.find(function (item) {
      var capacityAllows = !item.capacity || item.capacity.mode !== 'maximum' || item.capacity.people >= people;
      return item.rank >= targetRank && capacityAllows;
    });
    return product || catalog[catalog.length - 1] || catalog[0];
  }

  function productByHandle(handle) {
    return catalog.find(function (item) { return item.handle === handle; }) || null;
  }

  function auxiliaryCraftCount(profile) {
    var declared = Math.max(0, Number(profile.auxiliaryCraft) || 0);
    if (declared === 0 && (profile.kitTransfer === 'occasional' || profile.kitTransfer === 'routine' || profile.risks.indexOf('tenders') !== -1)) return 1;
    return declared;
  }

  function portableDistributionFor(profile) {
    return planningEngine.layoutPlan(profile).quickGrabCount > 0;
  }

  function coverageLocationCount(profile) {
    return planningEngine.layoutPlan(profile).responseZones;
  }

  function chooseKit(profile) {
    var decision = planningEngine.targetRank(profile);
    var level = decision.voyage.upgrade;
    var commercial = profile.operation !== 'private';
    var adventurer = productByHandle('ruck-60-advanced');
    var targetRank = decision.targetRank;
    if (adventurer && decision.compactDayCraft) targetRank = adventurer.rank;

    var kit = targetRank === (adventurer && adventurer.rank) ? adventurer : productAtOrAboveRank(targetRank, profile.total);
    var index = Math.max(0, catalog.indexOf(kit));

    var reasons = [];
    if (kit && kit.handle === 'ruck-60-advanced') reasons.push('The live Adventurer inventory is intentionally selected for this compact, private, day-use profile. It provides a waterproof quick-grab layer for single-incident trauma, bleeding control, basic airway, medication, burn, wound, and first-aid needs without pricing this small craft as though it were an offshore yacht.');
    else if (kit && kit.handle === 'ems-1400-medical-kit') reasons.push('The current EMS-1400 inventory provides greater supply depth and patient-assessment capability than the Adventurer while remaining proportionate for this near-shore profile.');
    else if (kit && kit.handle === 'ems-1500-medical-kit') reasons.push('The current EMS-1500 inventory adds BVM airway support and deeper trauma reserves over the EMS-1400.');
    else if (kit && kit.handle === 'ems-1550-medical-kit') reasons.push('The current EMS-1550 inventory adds onboard oxygen plus blood-pressure and blood-glucose monitoring.');
    else if (kit && kit.handle === 'ems-1600-medical-kit') reasons.push('The current EMS-1600 inventory includes AED and oxygen capability and is D-Dey’s published 10+ patient platform.');
    else if (kit) reasons.push('Selected from the current live EMS catalog using its product rank and published capability description.');

    if (kit && kit.capacity && kit.capacity.mode === 'maximum') reasons.push('The published ' + kit.capacity.people + '-person capacity statement supports the expected complement; products with a lower stated maximum are excluded.');

    var lengthLabel = profile.length + ' ' + profile.lengthUnit;
    if (profile.lengthFeet < 40) reasons.push('The ' + lengthLabel + ' vessel footprint is considered with the deck plan, storage, people aboard, and tender use when deciding whether portable access adds value.');
    else if (profile.lengthFeet < 80) reasons.push('The ' + lengthLabel + ' vessel footprint is one layout input; it does not increase the kit capability or quantity without supporting access, voyage, or population factors.');
    else reasons.push('The ' + lengthLabel + ' vessel footprint is evaluated with deck separation, storage, tender operations, and people aboard. Length alone does not multiply medical systems or add advanced modules.');

    var layout = planningEngine.layoutPlan(profile);
    if (layout.quickGrabCount > 0) {
      reasons.push('Length, deck separation, storage, and auxiliary-craft use were evaluated together. They support one primary system plus ' + layout.quickGrabCount + ' portable quick-grab ' + (layout.quickGrabCount === 1 ? 'position' : 'positions') + '—not a full medical system on every deck.');
    } else if (profile.decks > 1) {
      reasons.push('The layout does not independently multiply the package; one primary medical station remains the starting point unless another access factor is present.');
    } else {
      reasons.push('A single operational level allows the primary EMS location to remain centralized and immediately accessible.');
    }

    var transferCraft = auxiliaryCraftCount(profile);
    if (transferCraft > 0) {
      reasons.push('The plan includes ' + transferCraft + ' portable deployment ' + (transferCraft === 1 ? 'unit' : 'units') + ' that can leave assigned mothership stations with tenders, chase boats, fishing skiffs, or tow-along vessels and return for inspection and restocking.');
    }

    if (profile.distance <= 3) reasons.push('Near-shore response profile with relatively short access to shoreside help.');
    else if (profile.distance <= 20) reasons.push('Coastal range increases the time your crew may need to stabilize a patient.');
    else if (profile.distance <= 60) reasons.push('Offshore range makes expanded trauma, medical, and monitoring capability prudent.');
    else reasons.push('Remote or bluewater range creates the potential for prolonged care before evacuation.');

    if (profile.total <= 4) reasons.push('A small onboard complement of ' + profile.total + ' people keeps reserve depth relatively modest.');
    else if (profile.total <= 12) reasons.push('A complement of ' + profile.total + ' passengers and crew warrants expanded supply depth.');
    else reasons.push('A large complement of ' + profile.total + ' people warrants the largest base and a distributed-access review.');

    if (profile.duration === 0) reasons.push('Day-trip duration keeps routine medication and prolonged-care demands lower.');
    else if (profile.duration <= 1) reasons.push('Overnight operations justify broader illness, injury, and environmental coverage.');
    else reasons.push('Multi-day duration raises the value of diagnostics, medications, support, and refit planning.');

    if (commercial) reasons.push('Commercial status is considered with the voyage, people aboard, expected delay to care, and operating risks; it does not raise the package by itself.');
    else if (profile.complianceIntent === 'readiness') reasons.push('Practical-readiness mode keeps flag-state compliance modules out of the price estimate unless the voyage or people aboard independently indicate them.');
    if (profile.risks.length) reasons.push('Selected operating factors call for a custom risk and placement review.');

    return { product: kit, index: index, level: level, decision: decision, reasons: reasons.slice(0, 4) };
  }

  function capabilityGapKeys(larger, smaller) {
    return ['bvm', 'oxygen', 'monitoring', 'aed'].filter(function (key) {
      return larger.capabilities[key] && !smaller.capabilities[key];
    });
  }

  function capabilityGap(larger, smaller) {
    var labelsByKey = {
      bvm: 'BVM airway support',
      oxygen: 'onboard oxygen',
      monitoring: 'advanced monitoring',
      aed: 'AED capability'
    };
    return capabilityGapKeys(larger, smaller).map(function (key) { return labelsByKey[key]; });
  }

  function addonForCapability(key) {
    if (key === 'bvm') return addons.airway;
    if (key === 'monitoring') return addons.monitoring;
    return addons[key];
  }

  function modularProductFor(recommendation) {
    var primary = recommendation.product;
    for (var i = recommendation.index - 1; i >= 0; i -= 1) {
      var candidate = catalog[i];
      if (!candidate) continue;
      var gaps = capabilityGapKeys(primary, candidate);
      var completable = gaps.every(function (key) {
        var addon = addonForCapability(key);
        return addon && addon.title;
      });
      if (completable) return candidate;
    }
    return primary;
  }

  function compactProductFor(recommendation) {
    var fallback = catalog[Math.max(0, recommendation.index - 1)] || catalog[0] || recommendation.product;
    for (var i = recommendation.index - 1; i >= 0; i -= 1) {
      var candidate = catalog[i];
      if (candidate && !candidate.capabilities.aed && !candidate.capabilities.oxygen) return candidate;
    }
    return fallback;
  }

  function configurationOptions(profile, recommendation) {
    var primary = recommendation.product;
    var smallest = catalog[0] || primary;
    var portableCount = planningEngine.layoutPlan(profile).quickGrabCount;
    var portableTitle = primary.title + ' × 1';
    if (portableCount > 0 && primary.handle !== smallest.handle) portableTitle += ' + ' + smallest.title + ' × ' + portableCount;

    return [
      {
        label: 'SINGLE-CASE OPTION',
        title: primary.title + ' × 1',
        text: 'The simplest starting configuration: the selected capability level in one primary EMS case.',
        link: primary.url,
        action: 'View single-case system'
      },
      {
        label: 'PORTABLE-ACCESS OPTION',
        title: portableTitle,
        text: portableCount > 0
          ? 'Keeps one primary medical platform and adds only the compact quick-grab count supported by the combined layout and auxiliary-craft answers. These are access units, not duplicate whole-vessel systems.'
          : 'This profile does not establish a second access need. D-Dey can still review an optional quick-grab position from the actual general-arrangement plan.',
        link: portableCount > 0 && primary.handle !== smallest.handle ? smallest.url : '#DraConcierge',
        action: portableCount > 0 ? 'View portable unit' : 'Request placement review'
      },
      {
        label: 'CUSTOM SPLIT-CASE OPTION',
        title: 'Same capability, vessel-specific case plan',
        text: 'For tight corridors or fragmented storage, D-Dey can divide the verified aggregate inventory across smaller marked cases. The split is quoted only after contents, quantities, access, and return/restock controls are mapped; it is not created by multiplying smaller catalog kits.',
        link: '#DraConcierge',
        action: 'Request split-case review'
      }
    ];
  }

  function survivalAuthorityFor(profile) {
    var result = {
      label: profile.flagState + ' flag-state survival review',
      summary: 'The vessel’s flag administration and applicable port-state authorities determine required approved lifesaving appliances, survival-craft equipment, certifications, servicing, and carriage quantities.'
    };

    if (profile.flag === 'us' && profile.operation === 'private') {
      result.label = 'USCG recreational safety-equipment context';
      result.summary = 'The U.S. Coast Guard and applicable state authorities control required approved flotation and distress-signaling equipment. The Guardian suggestion adds organized survival capability but does not replace those required devices.';
    } else if (profile.flag === 'us') {
      result.label = 'USCG commercial-vessel survival context';
      result.summary = 'The applicable U.S. Coast Guard vessel rules, service, route, documentation, and Certificate of Inspection determine required survival craft and approved equipment. Guardian remains a supplemental grab-and-survival system.';
    } else if (profile.flag === 'uk') {
      result.label = 'UK MCA life-saving-appliance context';
      result.summary = 'The Maritime and Coastguard Agency framework varies with vessel use, length, voyage and operating category. Guardian supplements, but does not replace, required approved life-saving appliances or survival-craft equipment.';
    } else if (profile.flag === 'red-ensign') {
      result.label = 'Red Ensign registry / REG Yacht Code context';
      result.summary = 'The member registry administration determines applicability and acceptance under the Red Ensign Group yacht framework. Required life-saving appliances must follow the applicable approved standard; Guardian is additional survival capability.';
    } else if (profile.flag === 'marshall') {
      result.label = 'RMI Maritime Administrator survival context';
      result.summary = 'The Republic of the Marshall Islands Yacht Code and applicable marine notices govern approved life-saving appliances for the vessel’s status. Guardian is supplemental equipment and is not represented as an approved substitute.';
    } else if (profile.flag === 'malta') {
      result.label = 'Transport Malta yacht-code context';
      result.summary = 'The applicable Transport Malta yacht code controls certified life-saving appliances, location, servicing, and vessel documentation. Guardian adds survival depth but does not replace the approved equipment required by that code.';
    }

    return result;
  }

  function chooseGuardian(profile) {
    if (!guardianCatalog.length) return null;
    var smallCraftDay = isSmallCraftDayProfile(profile);
    var guardianDecision = planningEngine.guardianTier(profile);
    var level = guardianDecision.tier;

    var eligible = guardianCatalog.filter(function (item) { return item.tier <= level; });
    if (smallCraftDay && !eligible.length) return null;
    var product = eligible.length ? eligible[eligible.length - 1] : guardianCatalog[0];
    var index = guardianCatalog.indexOf(product);

    var quantity = Math.max(1, planningEngine.layoutPlan(profile).tenderUnits);

    var reasons = [];
    if (level === 0 && smallCraftDay) reasons.push('A private small-craft day profile through 20 nautical miles favors the compact inshore Guardian tier and a rapid-grab stowage plan.');
    else if (level === 0) reasons.push('Day operation within 3 nautical miles favors the smallest current Guardian configuration and a rapid-grab stowage plan.');
    else if (level === 1) reasons.push('Multiple moderate voyage, care-access, mission, and vessel factors align with the Coastal tier; its published inventory covers hydration, rations, medical support, signaling, shelter, navigation, repair, emergency power, and PLB location capability.');
    else reasons.push('Open Water was selected only because multiple bluewater indicators align across range, duration, expected delay to care, vessel mission, and operating profile. Its published configuration adds included VHF communication and a broader delayed-rescue platform; both current Guardian tiers include PLB location capability.');
    if (quantity > 1) reasons.push(quantity + ' Guardian units are suggested because the declared people-away and simultaneous auxiliary-craft profile creates separate operating groups—not because of vessel length or deck count alone.');
    else reasons.push('One primary grab location is the suggested starting point; vessel length and deck count do not multiply Guardian systems by themselves.');
    if (profile.storage === 'compact' && product.tier >= 2) reasons.push('The selected capability should be retained; D-Dey can review a custom split-case arrangement instead of silently replacing included communication or locator capability with smaller cases.');

    var alternatives = guardianCatalog.filter(function (item) { return item.handle !== product.handle; });
    var alternative = null;
    if (alternatives.length) {
      alternatives.sort(function (a, b) {
        return Math.abs(a.tier - product.tier) - Math.abs(b.tier - product.tier) || sortGuardianCatalog(a, b);
      });
      alternative = alternatives[0];
    }

    return {
      product: product,
      alternative: alternative,
      index: index,
      level: level,
      quantity: quantity,
      reasons: reasons,
      authority: survivalAuthorityFor(profile)
    };
  }

  function mcaCategoryFor(profile) {
    if (profile.flag === 'uk' && ['A', 'B', 'C'].indexOf(profile.mcaCategory) !== -1) return profile.mcaCategory;
    if (profile.distance > 175) return 'A';
    if (profile.distance <= 60 && profile.accommodation === 'no') return 'C';
    return 'B';
  }

  function modulePlanFor(profile, recommendation, compliance) {
    var primary = recommendation.product;
    var emsPlan = primary;
    var mcaCategory = mcaCategoryFor(profile);
    var compliancePlanning = profile.complianceIntent !== 'readiness' &&
      (!profile.regulatoryState || profile.regulatoryState.recommendationMode !== 'custom_review_only');
    var mcaCategoryAB = compliancePlanning && compliance.type === 'uk-mca' && mcaCategory !== 'C';
    var customMcaCategoryAMedication = mcaCategoryAB && mcaCategory === 'A';
    var usCruiseAed = compliancePlanning && profile.flag === 'us' &&
      profile.operation === 'charter' &&
      profile.accommodation === 'yes' &&
      profile.passengers >= 250 &&
      (profile.operatingWaters === 'us' || profile.operatingWaters === 'international');
    var readinessPlan = planningEngine.advancedModulePlan(profile, emsPlan.capabilities);
    var readinessAed = readinessPlan.aed;
    var mcaRiskAed = mcaCategoryAB && (profile.operation === 'charter' || profile.total > 12 || profile.distance > 60 || profile.duration >= 3);
    var aedQuantity = 1;

    var oxygenCompliance = mcaCategoryAB;
    var oxygenReadiness = readinessPlan.oxygen;
    var oxygenQuantity = oxygenCompliance ? 2 : 1;

    var trainedForRxIv = profile.training === 'marine' || profile.training === 'advanced';
    var ivTrainingRequired = !trainedForRxIv && (mcaCategoryAB || readinessPlan.iv);
    var rxTrainingRequired = !trainedForRxIv && !customMcaCategoryAMedication && (mcaCategoryAB || readinessPlan.rx);
    var ivReadiness = readinessPlan.iv;
    var ivQuantity = mcaCategoryAB ? 2 : 1;

    return {
      mcaCategory: mcaCategory,
      emsPlan: emsPlan,
      aed: {
        coveredByEms: Boolean(emsPlan.capabilities && emsPlan.capabilities.aed),
        include: !emsPlan.capabilities.aed && (usCruiseAed || mcaRiskAed || readinessAed),
        quantity: aedQuantity,
        complianceDriven: usCruiseAed,
        mcaRiskDriven: mcaRiskAed
      },
      oxygen: {
        coveredByEms: Boolean(emsPlan.capabilities && emsPlan.capabilities.oxygen),
        include: !emsPlan.capabilities.oxygen && (oxygenCompliance || oxygenReadiness),
        quantity: oxygenQuantity,
        complianceDriven: oxygenCompliance
      },
      iv: {
        include: mcaCategoryAB || ivReadiness,
        quantity: ivQuantity,
        complianceDriven: mcaCategoryAB,
        trained: trainedForRxIv,
        trainingRequired: ivTrainingRequired
      },
      rx: {
        include: !customMcaCategoryAMedication && (mcaCategoryAB || readinessPlan.rx),
        complianceDriven: mcaCategoryAB && !customMcaCategoryAMedication,
        customComplianceBuild: customMcaCategoryAMedication,
        trained: trainedForRxIv,
        trainingRequired: rxTrainingRequired
      },
      support: {
        include: readinessPlan.support
      },
      airway: {
        include: false,
        quantity: 0
      },
      monitoring: {
        include: false,
        quantity: 0
      }
    };
  }

  function embeddedCapabilityNote(product) {
    var notes = [];
    if (product.capabilities && product.capabilities.aed) {
      notes.push('Its published inventory already includes AED capability, so a second AED is not double-counted. D-Dey normally supplies the currently available AED model; Defibtech Lifeline is the advisor reference, and a client-specified alternative may change the price.');
    }
    if (product.capabilities && product.capabilities.oxygen) {
      notes.push('Its published inventory already includes oxygen capability, so a separate oxygen module is not double-counted.');
    }
    return notes.length ? ' ' + notes.join(' ') : '';
  }

  function suggestedPackageFor(profile, recommendation, guardian, compliance) {
    var primary = recommendation.product;
    var smallest = catalog[0] || primary;
    var adventurer = productByHandle('ruck-60-advanced');
    var quickGrab = adventurer || smallest;
    var modulePlan = modulePlanFor(profile, recommendation, compliance);
    var items = [];
    var layout = planningEngine.layoutPlan(profile);

    function addItem(key, category, product, quantity, rationale) {
      if (!product || !product.title || quantity < 1) return;
      items.push({
        key: key,
        category: category,
        title: product.title,
        url: product.url || '#DraConcierge',
        variantId: product.variantId || '',
        image: product.image || '',
        price: product.price || '',
        priceCents: Number(product.priceCents) || 0,
        suggestedQuantity: quantity,
        quantity: quantity,
        rationale: rationale
      });
    }

    addItem(
      'ems-primary',
      'PRIMARY EMS SYSTEM',
      primary,
      1,
      'One primary medical platform selected from the combined people, voyage, expected-care-delay, operating-risk, and mission profile. Vessel length does not multiply this system.' + embeddedCapabilityNote(primary)
    );
    if (layout.quickGrabCount > 0 && quickGrab.handle !== primary.handle) {
      addItem(
        'ems-distributed',
        'ADVENTURER QUICK-GRAB ACCESS',
        quickGrab,
        layout.quickGrabCount,
        'Portable access is capped from the combined deck separation, storage, people-away, and auxiliary-craft answers. The same marked units can serve onboard response stations when auxiliary craft are stowed, so they are not counted twice.'
      );
    }

    if (profile.training === 'none' || profile.training === 'basic') {
      addItem(
        'elsm-training',
        'RECOMMENDED TRAINING · STANDARD ELS-M COURSE',
        addons.training,
        1,
        'Included because the highest reported onboard training is below ELS-M. This priced line is one seat in D-Dey’s standard one-day, hands-on ELS-M course in Stuart, Florida. The current course includes maritime emergency medical instruction and CPR/AED, First Aid, and bleeding-control certification pathways. Private on-site instruction and online training are also available; D-Dey will help select the delivery format and number of trained responders appropriate for the vessel.'
      );
    }

    if (modulePlan.rx.customComplianceBuild) {
      items.push({
        key: 'mca-category-a-medication-chest',
        category: 'REQUIRED CUSTOM MCA MEDICATION SYSTEM',
        title: 'Custom MCA Category A Medication Chest',
        url: '#DraConcierge',
        variantId: '',
        image: '',
        price: '',
        priceCents: 0,
        priceLabel: 'Custom quote required',
        suggestedQuantity: 1,
        quantity: 1,
        fixedQuantity: true,
        customRequired: true,
        linkLabel: 'Request custom medication quote →',
        rationale: 'Required to pursue the selected MCA Category A pathway. The published D-Dey RX Medication Module is intentionally not substituted here because it provides only partial medication coverage and cannot satisfy the required treatment breadth, strengths, dosage forms, or planning quantities. D-Dey will configure and quote this vessel-specific medication chest after crew-count, voyage-risk, prescription, and qualified medical/pharmacy review.'
      });
    }

    if (modulePlan.aed.include) {
      var aedRationale = modulePlan.aed.complianceDriven
        ? 'Automatically included because this U.S.-flag passenger profile reaches the large-passenger-vessel medical-center screening threshold. D-Dey must confirm actual statutory applicability, placement, maintenance, training, and the vessel’s Certificate of Inspection before representing compliance.'
        : modulePlan.aed.mcaRiskDriven
          ? 'Automatically included because the current UK MCA pathway treats defibrillator carriage as a vessel-specific risk-assessment decision and this profile warrants that capability.'
          : 'Automatically included because multiple factors align across people aboard, voyage exposure, care access, mission risk, and vessel layout. No one answer triggers it by itself.';
      aedRationale += ' Defibtech Lifeline is the advisor’s reference AED. D-Dey may fulfill with a comparable model available at the time unless the client specifies otherwise; a specified alternative may incur additional fees.';
      addItem('aed', 'AUTOMATIC AED CAPABILITY', addons.aed, modulePlan.aed.quantity, aedRationale);
    }

    if (modulePlan.oxygen.include) {
      var oxygenRationale = modulePlan.oxygen.complianceDriven
        ? 'Automatically included as a starting oxygen module for the likely MCA Category ' + modulePlan.mcaCategory + ' pathway. Two current 250L D-Dey oxygen kits provide 500L gross cylinder capacity; D-Dey must still confirm the completed giving set, flow capability, consumables, stowage, training, and regulator acceptance.'
        : 'Automatically included because multiple factors align across people aboard, voyage exposure, expected delay to care, and operating risk, while the selected EMS platform does not already include oxygen.';
      addItem('oxygen', 'AUTOMATIC OXYGEN CAPABILITY', addons.oxygen, modulePlan.oxygen.quantity, oxygenRationale);
    }

    if (modulePlan.iv.include) {
      var ivRationale = modulePlan.iv.trainingRequired
        ? 'Included because multiple remote-care factors support reviewing IV-fluid capability. Fulfillment remains conditional on D-Dey screening, qualification verification, prescription and clinical review, and destination law. Private, D-Dey classroom, and online ELS-M training options are available; D-Dey may hold or decline the IV portion when those conditions are not completed.'
        : modulePlan.iv.complianceDriven
          ? 'Automatically included as a starting IV capability for the likely MCA Category ' + modulePlan.mcaCategory + ' pathway. The current schedule addresses IV or IO access depending on training and IV fluid capability; VOYAGER IV is prescription-controlled and does not by itself complete every fluid type, volume, access, flush, quantity, or documentation requirement. D-Dey will complete the custom build and confirm the trained-user pathway.'
          : 'Automatically included because ELS-M-or-higher training and multiple remote-care factors align across range, voyage duration, and expected time to professional help. VOYAGER IV is prescription-controlled and requires D-Dey medical screening, qualification verification, and destination-law review before supply or use. D-Dey contacts purchasers whose qualifications or clinical relationship are not already on file before fulfillment.';
      addItem('iv', 'AUTOMATIC IV CAPABILITY', addons.iv, modulePlan.iv.quantity, ivRationale);
    }

    if (modulePlan.airway.include) {
      addItem(
        'airway',
        'PORTABLE AIRWAY CAPABILITY',
        addons.airway,
        modulePlan.airway.quantity,
        'Included because the selected portable EMS cases do not independently reproduce the BVM airway capability of the larger target platform. D-Dey verifies compatible masks, placement, training, and the combined quantity before supply.'
      );
    }

    if (modulePlan.monitoring.include) {
      addItem(
        'monitoring',
        'PORTABLE PATIENT-MONITORING CAPABILITY',
        addons.monitoring,
        modulePlan.monitoring.quantity,
        'Included because the selected portable EMS cases do not independently reproduce the monitoring capability of the larger target platform. D-Dey verifies the actual devices, consumables, placement, and combined quantity before supply.'
      );
    }

    if (guardian) {
      addItem(
        'guardian',
        'GUARDIAN SURVIVAL SYSTEM',
        guardian.product,
        guardian.quantity,
        guardian.reasons.join(' ')
      );
    }

    if (modulePlan.support.include) {
      addItem(
        'support',
        'MEDICAL SUPPORT ADD-ON',
        addons.support,
        1,
        'Suggested so the crew can reach D-Dey medical support and connect expiration monitoring to the onboard system.'
      );
    }

    if (modulePlan.rx.include) {
      var rxRationale = modulePlan.rx.trainingRequired
        ? 'Included because the compliance-conscious or remote-care profile supports reviewing medication capability. The purchaser must complete D-Dey screening and demonstrate appropriate training before fulfillment; D-Dey may hold or decline the RX portion when those conditions are not met. Private, D-Dey classroom, and online ELS-M training options are available.'
        : modulePlan.rx.complianceDriven
          ? 'Included as a starting medication module for the selected compliance-conscious Category A/B pathway; D-Dey must complete the exact medicine, quantity, prescription, pharmacy, and training review.'
          : 'Included because ELS-M-or-higher training and multiple remote-care indicators align across distance, voyage duration, and expected time to professional care. Supply remains subject to D-Dey medical screening, prescription approval, qualification verification, and destination law. D-Dey contacts purchasers whose qualifications or clinical relationship are not already on file before fulfillment.';
      addItem(
        'rx',
        'MEDICATION ADD-ON',
        addons.rx,
        1,
        rxRationale
      );
    }

    return items;
  }

  function guardianCards(guardian) {
    if (!guardian) return [];
    var product = guardian.product;
    var stowageText = guardian.quantity > 1
      ? 'The additional count corresponds to simultaneous portable operating groups declared in the questionnaire, not vessel length or deck count. D-Dey confirms the final number and locations from the vessel plan.'
      : 'One clearly marked, immediately accessible grab location is the suggested starting point. D-Dey confirms final stowage against the vessel’s abandonment plan.';
    return [
      {
        label: 'SUGGESTED GUARDIAN',
        title: product.title + ' × ' + guardian.quantity,
        text: product.summary + ' ' + stowageText + (product.price ? ' Current unit price ' + product.price + '.' : ''),
        link: product.url,
        action: 'View Guardian system',
        priority: true
      },
      guardian.alternative ? {
        label: 'OTHER CURRENT GUARDIAN OPTION',
        title: guardian.alternative.title,
        text: 'Available for a different operating profile, but not selected as the starting package for the voyage entered. ' + guardian.alternative.summary,
        link: guardian.alternative.url,
        action: 'Compare Guardian option'
      } : {
        label: 'SELECTION BASIS',
        title: 'Voyage exposure and access',
        text: guardian.reasons.join(' ') + ' This is a readiness suggestion, not a statutory quantity.',
        link: '#DraConcierge',
        action: 'Request stowage review'
      },
      {
        label: 'FLAG-STATE CONTEXT',
        title: guardian.authority.label,
        text: guardian.authority.summary + ' A compliance-configured survival package requires a custom D-Dey order.',
        link: '#DraConcierge',
        action: 'Request survival review'
      }
    ];
  }

  function complianceFor(profile) {
    var compliancePlanning = profile.complianceIntent !== 'readiness';
    var framework = 'the current ' + profile.flagState + ' flag-state framework';
    if (profile.flag === 'us') framework = 'current U.S. Coast Guard and applicable state frameworks';
    else if (profile.flag === 'uk') framework = 'the current UK Maritime and Coastguard Agency framework';
    else if (profile.flag === 'red-ensign') framework = 'the current Red Ensign Group and member-registry frameworks';
    else if (profile.flag === 'marshall') framework = 'the current Republic of the Marshall Islands yacht framework';
    else if (profile.flag === 'malta') framework = 'the current Transport Malta yacht framework';

    var result = {
      label: profile.flagState.toUpperCase() + ' · ' + labels.operation[profile.operation].toUpperCase(),
      heading: 'A compliance-configured system would be a custom D-Dey order.',
      status: 'CUSTOM COMPLIANCE ORDER',
      type: 'flag-review',
      summary: 'The suggested package gives you a practical idea of likely scale and capability, but it is not represented as satisfying ' + framework + '. If you request that standard, D-Dey will review the vessel documents and voyages, then prepare one custom order without publishing a stand-alone procurement list.',
      actions: [
        'Verify the vessel’s registration, operating status, certification, and intended voyages.',
        'Cross-check the controlling framework privately against the current D-Dey inventory.',
        'Prepare one consolidated D-Dey system, support, training, and service proposal for approval.'
      ]
    };

    if (!compliancePlanning) {
      result.heading = 'This is a practical-readiness estimate, not a compliance build.';
      result.status = 'READINESS FIRST · REVIEW OPTIONAL';
      result.type = 'readiness-only';
      result.summary = 'You asked the advisor to prioritize a proportionate onboard-readiness package. Flag-state and agency rules are therefore shown as review context but do not automatically add compliance-driven equipment to the price estimate. If a named standard later matters, D-Dey must re-screen and supply the vessel-specific configuration as a custom order.';
      result.actions = [
        'Use the people aboard, voyage exposure, vessel layout, and response zones to shape the starting package.',
        'Keep statutory life-saving appliances and any separately required equipment outside this non-certified estimate.',
        'Request a D-Dey compliance review before relying on the package for any agency, flag-state, insurer, charter, or commercial obligation.'
      ];
    } else if (profile.flag === 'us' && profile.operation === 'charter') {
      result.heading = 'The EMS base requires an ISO verification and completion review.';
      result.status = 'CUSTOM USCG ORDER';
      result.type = 'us-iso';
      result.summary = 'For an inspected U.S. passenger-vessel pathway, D-Dey’s published EMS inventory alone does not establish ISO 18813 self-certification or regulatory equivalency. D-Dey must confirm the completed system, instructions, markings, expiration controls, and vessel-specific acceptance before any compliance representation.';
      result.actions = [
        'Confirm the vessel’s Certificate of Inspection, route, and applicable USCG pathway.',
        'Verify the completed D-Dey configuration, documentation, instructions, and markings privately.',
        'Issue a vessel-specific proposal without exposing a stand-alone procurement list.'
      ];
    } else if (profile.flag === 'us' && profile.operation === 'fishing') {
      result.heading = 'USCG medicine-chest suitability must be determined for this vessel.';
      result.status = 'CUSTOM USCG ORDER';
      result.type = 'us-fishing';
      result.summary = 'The U.S. commercial-fishing rule calls for a medicine chest suitable for the number of individuals aboard rather than a universal item schedule. The EMS base is a readiness recommendation; D-Dey must complete and document the vessel-specific suitability review before making a compliance representation.';
    } else if (profile.flag === 'uk' && (profile.operation !== 'private' || profile.crew > 0)) {
      var selectedMcaCategory = mcaCategoryFor(profile);
      var selectedMcaLabel = labels.mcaCategory[profile.mcaCategory] || ('Provisional Category ' + selectedMcaCategory + ' from the voyage profile');
      var categoryAMedicationBoundary = selectedMcaCategory === 'A'
        ? ' The standard D-Dey RX Medication Module is intentionally excluded from the priced Category A suggestion because it contains only partial medication coverage and is not close to the required Category A breadth or quantities. The complete medication chest must be custom-built and quoted after line-item and qualified medical/pharmacy review.'
        : '';
      result.heading = 'The EMS base requires a custom MCA medical-stores build.';
      result.status = 'CUSTOM MCA ORDER';
      result.type = 'uk-mca';
      result.summary = selectedMcaLabel + ' was recorded for this planning screen. The current D-Dey EMS and RX published inventories do not form a complete MCA Annex 1 configuration.' + categoryAMedicationBoundary + ' D-Dey must verify that category from the vessel documents, privately complete the medicine and equipment modules, set quantities through the required risk review, and confirm vessel documentation before any compliance representation.';
      result.actions = [
        'Verify the stated MCA category against the vessel’s documents, operating limits, and voyages.',
        'Build the missing medicine and equipment modules privately around the selected EMS base.',
        'Obtain the required qualified review and prepare one consolidated D-Dey proposal.'
      ];
    } else if (profile.flag === 'uk') {
      result.heading = 'Confirm whether the private-pleasure-vessel exclusions apply.';
      result.status = 'CUSTOM UK REVIEW';
      result.type = 'uk-review';
      result.summary = 'Some UK private pleasure vessels may fall outside the merchant-shipping medical-stores regime, but the exclusion is fact-specific. The EMS base remains a readiness recommendation until D-Dey confirms ownership, employment, voyage, and vessel-document details.';
    }

    if (profile.complianceIntent === 'agency') {
      result.status = 'CUSTOM ORDER REQUEST · ' + result.status;
      result.heading = 'A vessel-specific compliance order must be completed with D-Dey.';
    }

    if (compliancePlanning && profile.regulatoryState && profile.regulatoryState.recommendationMode === 'custom_review_only') {
      result.status = 'UPDATED SOURCE · CUSTOM REVIEW REQUIRED';
      result.heading = 'An official-source update requires D-Dey review before compliance-driven additions are priced.';
      result.type = 'regulatory-hold';
      result.summary = (profile.regulatoryState.message || 'The affected regulatory pathway is being reviewed.') + ' The medical and Guardian quantities shown are therefore a practical readiness starting point only; the current approved rules have not been silently applied to a changed source, and no stand-alone compliance list is being published.';
      result.actions = [
        'D-Dey will compare the changed official source with the last approved version and the vessel documents.',
        'A qualified reviewer will update or reaffirm the private rule pack before compliance-driven equipment is added.',
        'The final custom proposal will identify the governing source version and the D-Dey inventory revision used.'
      ];
    }

    return result;
  }

  function advisorDatasetKey(prefix, kind) {
    return prefix + kind.charAt(0).toUpperCase() + kind.slice(1) + 'Endpoint';
  }

  function advisorEndpointCandidates(kind, query) {
    var mode = root.dataset.advisorEndpointMode || 'auto';
    var suffix = query || '';
    var candidates = [];
    var shopifyEndpoint = root.dataset[advisorDatasetKey('shopify', kind)];
    var publicEndpoint = root.dataset[advisorDatasetKey('public', kind)];
    if (mode !== 'public-bridge' && shopifyEndpoint) candidates.push({ endpoint: shopifyEndpoint + suffix, publicBridge: false });
    if (mode !== 'shopify' && publicEndpoint) candidates.push({ endpoint: publicEndpoint + suffix, publicBridge: true });
    return candidates;
  }

  function bridgeSessionToken(forceRefresh) {
    var sessionEndpoint = root.dataset.bridgeSessionEndpoint;
    var expiresAt = bridgeSession ? Date.parse(bridgeSession.expiresAt || '') : 0;
    if (!forceRefresh && bridgeSession && bridgeSession.token && expiresAt > Date.now() + 30000) return Promise.resolve(bridgeSession.token);
    if (!forceRefresh && bridgeSessionPromise) return bridgeSessionPromise;
    if (!sessionEndpoint) return Promise.reject(new Error('The temporary Advisor bridge is unavailable.'));
    bridgeSessionPromise = fetch(sessionEndpoint, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data.session || !data.session.token) throw new Error(data.message || 'The temporary Advisor bridge did not issue a session.');
        bridgeSession = data.session;
        return bridgeSession.token;
      });
    }).finally(function () {
      bridgeSessionPromise = null;
    });
    return bridgeSessionPromise;
  }

  function advisorFetchOptions(options, publicBridge, token) {
    var source = options || {};
    var requestOptions = {};
    Object.keys(source).forEach(function (key) { requestOptions[key] = source[key]; });
    var headers = {};
    Object.keys(source.headers || {}).forEach(function (key) { headers[key] = source.headers[key]; });
    requestOptions.headers = headers;
    requestOptions.credentials = publicBridge ? 'omit' : 'same-origin';
    if (publicBridge) {
      requestOptions.mode = 'cors';
      headers.Authorization = 'Bearer ' + token;
    }
    return requestOptions;
  }

  function fetchAdvisorEndpoint(kind, query, options) {
    var candidates = advisorEndpointCandidates(kind, query);
    function attempt(index) {
      var candidate = candidates[index];
      if (!candidate) return Promise.reject(new Error('The advisor service endpoint is unavailable.'));
      var tokenPromise = candidate.publicBridge ? bridgeSessionToken(false) : Promise.resolve('');
      return tokenPromise.then(function (token) {
        return fetch(candidate.endpoint, advisorFetchOptions(options, candidate.publicBridge, token)).then(function (response) {
          if (candidate.publicBridge && response.status === 401) {
            bridgeSession = null;
            return bridgeSessionToken(true).then(function (freshToken) {
              return fetch(candidate.endpoint, advisorFetchOptions(options, true, freshToken));
            });
          }
          return response;
        });
      }).then(function (response) {
        var retryable = response.status === 401 || response.status === 403 || response.status === 404 || response.status === 502 || response.status === 503 || response.status === 504;
        if (retryable && index + 1 < candidates.length) return attempt(index + 1);
        return response;
      }).catch(function (error) {
        if (index + 1 < candidates.length) return attempt(index + 1);
        throw error;
      });
    }
    return attempt(0);
  }

  function loadRegulatoryState(profile) {
    if (!advisorEndpointCandidates('regulatory').length) return Promise.resolve({
      recommendationMode: 'custom_review_only',
      status: 'monitoring_degraded',
      message: 'The live official-source monitor could not be confirmed for this request.'
    });
    var controller = window.AbortController ? new AbortController() : null;
    var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, 20000);
    var query = '?flagState=' + encodeURIComponent(profile.flagState);
    return fetchAdvisorEndpoint('regulatory', query, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Regulatory status endpoint returned ' + response.status + '.');
      return response.json();
    }).then(function (data) {
      if (!data || !data.regulatory) throw new Error('Regulatory status response was incomplete.');
      return data.regulatory;
    }).catch(function () {
      return {
        recommendationMode: 'custom_review_only',
        status: 'monitoring_degraded',
        message: 'The live official-source monitor could not be confirmed, so compliance-driven additions require a D-Dey custom review.'
      };
    }).finally(function () {
      window.clearTimeout(timeout);
    });
  }

  function packageFor(profile, recommendation, compliance, guardian) {
    var cards = [];
    var trainingNeeded = profile.training === 'none' || profile.training === 'basic';
    var primary = recommendation.product;
    var modulePlan = modulePlanFor(profile, recommendation, compliance);

    if (compliance.type === 'readiness-only') {
      cards.push({
        title: 'Readiness-first recommendation',
        text: 'This priced starting package is intentionally proportionate and does not include equipment solely because a possible flag-state or agency pathway might require it. D-Dey can convert it to a compliance-conscious custom order if the vessel’s actual obligations call for one.',
        link: '#DraConcierge',
        action: 'Ask about compliance only if needed'
      });
    } else if (compliance.type === 'us-iso') {
      cards.push({
        title: 'Custom USCG compliance order',
        text: 'The published EMS base is not presented as a self-certified ISO 18813 system. D-Dey will privately verify and complete the system, documentation, instructions, markings, and vessel-specific pathway before making any compliance representation.',
        link: '#DraConcierge',
        action: 'Request ISO review'
      });
    } else if (compliance.type === 'uk-mca') {
      cards.push({
        title: 'Custom MCA compliance order',
        text: modulePlan.rx.customComplianceBuild
          ? 'The standard RX module is intentionally not included in this Category A price estimate. It contains only partial medication coverage and cannot satisfy the Category A breadth or quantities. D-Dey will privately build and quote the complete Category A medication chest after exact line-item, quantity, prescription, and qualified medical/pharmacy review.'
          : 'The EMS base and standard RX module do not by themselves complete the current MCA schedule. D-Dey will determine the vessel category and privately build the required medicine, equipment, quantity, and documentation package around the selected base.',
        link: '#DraConcierge',
        action: 'Request MCA build'
      });
    } else if (compliance.type === 'us-fishing') {
      cards.push({
        title: 'Custom USCG compliance order',
        text: 'D-Dey will review the number aboard, operating pattern, expected delay to care, vessel documents, and current EMS inventory to configure and document a suitable onboard medicine-chest package.',
        link: '#DraConcierge',
        action: 'Request suitability review'
      });
    } else {
      cards.push({
        title: 'Custom ' + profile.flagState + ' compliance order',
        text: 'D-Dey will privately map the current flag-state and operating-area framework to this EMS base, then quote the complete D-Dey configuration as one coordinated system.',
        link: '#DraConcierge',
        action: 'Request private review'
      });
    }
    if (isSmallCraftDayProfile(profile) && !guardian && guardianCatalog.length) {
      cards.push({
        title: 'Small-craft Guardian review',
        text: 'The advisor did not substitute the much larger Coastal Guardian simply because D-Dey’s smaller inshore Guardian configuration is not yet published. Once that tier is added to the Guardian collection, it will be considered automatically; until then, D-Dey can quote the appropriate small-craft survival option privately.',
        link: '#DraConcierge',
        action: 'Request the inshore Guardian option'
      });
    }
    if (portableDistributionFor(profile)) {
      cards.push({
        title: 'Portable access without duplicate systems',
        text: 'The priced plan keeps one primary capability platform and adds only the portable quick-grab units supported by the combined layout and tender answers. A unit assigned to a tender is not counted again as a separate mothership station.',
        link: '#DraConcierge',
        action: 'Request placement review'
      });
    }
    if (trainingNeeded) {
      cards.unshift({
        label: 'TRAINING RECOMMENDATION',
        title: 'Emergency Life Saver Marine training',
        text: modulePlan.rx.trainingRequired || modulePlan.iv.trainingRequired
          ? 'The RX and/or IV modules are included because multiple remote-care factors support reviewing those capabilities, but fulfillment remains conditional on D-Dey screening and appropriate training. ELS-M is available as private instruction for a vessel or team, in D-Dey’s classroom, or online. D-Dey may hold or decline the regulated portions when qualifications, prescriptions, or clinical review are not completed.'
            : 'The selected equipment is only useful when the people aboard can recognize priorities, retrieve the right module, communicate clearly, and operate within their training. ELS-M is available as private instruction for a vessel or team, in D-Dey’s classroom, or online.',
        link: '/products/emergency-life-saver-marine-course-els-m',
        action: 'View the standard ELS-M course',
        priority: true
      });
    }
    if (modulePlan.aed.include || modulePlan.oxygen.include || modulePlan.iv.include || modulePlan.airway.include || modulePlan.monitoring.include) {
      cards.push({
        title: 'Advanced modules already included',
        text: 'The priced suggestion above already includes the standalone AED, oxygen, IV, airway, and/or monitoring modules triggered by this profile and portable distribution plan. D-Dey will confirm equipment availability, aggregate quantities, placement, consumables, prescriptions, training, and any compliance completion before quoting the final vessel package.',
        link: '#DraConcierge',
        action: 'Review included modules'
      });
    }
    cards.push({
      title: 'Inspection and refit plan',
      text: 'Add D-Dey inspection, expiration monitoring, post-use replenishment, and scheduled refit support so the complete system remains ready between voyages.',
      link: '#DraConcierge',
      action: 'Include in concierge review'
    });
    return cards;
  }

  function addText(parent, tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = text;
    parent.appendChild(node);
    return node;
  }

  function renderConciergeSuggestions(questions) {
    var suggestions = document.getElementById('DraAdvisorSuggestions');
    if (!suggestions) return;
    suggestions.innerHTML = '';
    (questions || []).slice(0, 3).forEach(function (question) {
      var button = addText(suggestions, 'button', '', question);
      button.type = 'button';
      button.dataset.conciergeQuestion = question;
      button.disabled = conciergeBusy;
    });
  }

  function addConciergeMessage(role, text) {
    var messages = document.getElementById('DraAdvisorMessages');
    if (!messages || !text) return;
    var message = document.createElement('div');
    message.className = 'dra__advisor-message dra__advisor-message--' + (role === 'user' ? 'client' : 'advisor');
    addText(message, 'span', 'dra__advisor-message-label', role === 'user' ? 'YOU' : 'D-DEY ADVISOR');
    addText(message, 'div', '', text);
    messages.appendChild(message);
    messages.scrollTop = messages.scrollHeight;
  }

  function setConciergeBusy(busy) {
    conciergeBusy = busy;
    var formNode = document.getElementById('DraAdvisorQuestionForm');
    var questionNode = document.getElementById('DraAdvisorQuestion');
    var submit = formNode ? formNode.querySelector('button[type="submit"]') : null;
    if (questionNode) questionNode.disabled = busy;
    if (submit) {
      submit.disabled = busy;
      submit.textContent = busy ? 'Reviewing…' : 'Ask →';
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-concierge-question]'), function (button) { button.disabled = busy; });
  }

  function resetAdvisorConcierge() {
    var messages = document.getElementById('DraAdvisorMessages');
    var responseStatus = document.getElementById('DraAdvisorResponseStatus');
    var escalation = document.getElementById('DraAdvisorEscalation');
    var question = document.getElementById('DraAdvisorQuestion');
    conciergeHistory = [];
    if (messages) messages.innerHTML = '';
    if (question) question.value = '';
    if (responseStatus) responseStatus.textContent = 'Uses this brief and the live D-Dey catalog. The advisor service does not retain this conversation.';
    if (escalation) escalation.hidden = true;
    addConciergeMessage('assistant', 'I’m here to help you understand the recommendation in detail. I can explain why these D-Dey systems were selected, how they may be arranged across decks, limited storage, or auxiliary craft, and where a private D-Dey review remains important.');
    renderConciergeSuggestions([
      'Why did the advisor choose this EMS base?',
      'How could D-Dey arrange these kits around storage and tenders?',
      'What still needs a custom D-Dey review?'
    ]);
  }

  function conciergePackagePayload() {
    return activePackageItems.map(function (item) {
      return {
        role: item.category,
        category: item.category,
        title: item.title,
        quantity: item.quantity,
        suggestedQuantity: item.suggestedQuantity,
        variantId: item.variantId || '',
        productUrl: item.url || '',
        customRequired: Boolean(item.customRequired)
      };
    });
  }

  function conciergeFallbackGuidance(question, profile, compliance, packageItems) {
    var cleanQuestion = String(question || '').replace(/\s+/g, ' ').trim();
    var normalizedQuestion = cleanQuestion.toLowerCase();
    var items = (packageItems || []).filter(function (item) { return Number(item.quantity) > 0; });
    var packageSummary = items.length ? items.map(function (item) {
      return Number(item.quantity) + ' × ' + item.title;
    }).join(', ') : 'the package shown above';
    var people = Math.max(1, Number(profile.total) || Number(profile.passengers) + Number(profile.crew) || 1);
    var length = profile.length ? profile.length + ' ' + (profile.lengthUnit || 'ft') : Math.round(Number(profile.lengthFeet) || 0) + ' ft';
    var range = labels.distance[String(profile.distance)] || 'the selected operating range';
    var duration = labels.duration[String(profile.duration)] || 'the selected voyage duration';
    var storage = labels.storage[profile.storage] || 'the selected storage arrangement';
    var mobility = labels.kitTransfer[profile.kitTransfer] || 'the selected equipment-mobility plan';
    var disclaimer = ' This explains the purchasing recommendation; it is not a certification or guarantee of compliance.';
    var suggestions = [
      'Why did the advisor choose this EMS base?',
      'How could D-Dey arrange these kits around storage and tenders?',
      'What still needs a custom D-Dey review?'
    ];

    if (/\b(emergency|unconscious|not breathing|severe bleeding|overdose)\b/.test(normalizedQuestion)) {
      return {
        answer: 'If this is happening now, please stop here and contact the appropriate emergency or maritime rescue service. Follow the vessel medical plan and qualified medical direction.',
        suggestedQuestions: suggestions,
        escalationRequired: true
      };
    }
    if (/\b(dose|dosage|strength|milligram|\d+\s*mg|exact medication|drug list|itemized|shopping list)\b/.test(normalizedQuestion)) {
      return {
        answer: 'I can explain why a medication or clinical capability may require a custom D-Dey module, but I cannot publish an exact drug, strength, quantity, or itemized procurement list. D-Dey must review the vessel, flag-state pathway, voyage profile, onboard qualifications, and medical direction before preparing that portion of the proposal.' + disclaimer,
        suggestedQuestions: ['What parts of this package require custom review?', 'Why is a custom medication module shown?', 'How does onboard training affect the recommendation?'],
        escalationRequired: true
      };
    }

    if (/\b(why|ems base|choose|chosen|recommend)\b/.test(normalizedQuestion)) {
      return {
        answer: 'For this ' + length + ' vessel carrying ' + people + ' people, the current recommendation is ' + packageSummary + '. The selection reflects the complete operating profile: ' + range + ', ' + duration + ', expected access to professional care, onboard training, vessel layout, storage, and auxiliary-craft use. No single answer—including vessel length—sets the package by itself. The objective is appropriate distributed medical capability without multiplying large kits unnecessarily.' + disclaimer,
        suggestedQuestions: suggestions,
        escalationRequired: Boolean(compliance && (compliance.type === 'regulatory-hold' || compliance.type === 'uk-review'))
      };
    }

    if (/\b(storage|tender|auxiliary|deck|arrange|placement|portable|corridor|space)\b/.test(normalizedQuestion)) {
      var distribution = Number(profile.decks) > 1
        ? 'With ' + profile.decks + ' operational levels, D-Dey would normally place or stage the portable systems so a trained responder can reach medical equipment without moving a cumbersome case through every corridor.'
        : 'With one primary operating level, the package can remain more centralized while keeping the quick-grab component immediately accessible.';
      var tenderPlan = Number(profile.auxiliaryCraft) > 0
        ? ' Your brief also allows for ' + profile.auxiliaryCraft + ' auxiliary craft with up to ' + profile.auxiliaryPeople + ' people away at once. Because equipment is ' + mobility.toLowerCase() + ', portable EMS equipment can be assigned to the departing craft instead of duplicating every onboard capability.'
        : ' No separate auxiliary-craft deployment was included in this brief.';
      return {
        answer: 'A practical arrangement begins with the suggested system, ' + packageSummary + ', and your storage preference, “' + storage + '.” ' + distribution + tenderPlan + ' Final placement should keep the AED, oxygen, primary trauma capability, and any custom medication module accessible to the appropriately trained responder.' + disclaimer,
        suggestedQuestions: suggestions,
        escalationRequired: false
      };
    }

    if (/\b(custom|review|compliance|flag|mca|uscg|missing|required|inspection)\b/.test(normalizedQuestion)) {
      var complianceHeading = compliance && compliance.heading ? compliance.heading : 'A vessel-specific regulatory review is still required.';
      var complianceSummary = compliance && compliance.summary ? compliance.summary : 'D-Dey must confirm the governing pathway and vessel documents before representing any package as compliance-ready.';
      var mcaNote = profile.mcaCategory === 'A'
        ? ' For MCA Category A, the standard online RX module is not treated as the required medical stores; a vessel-specific medication chest and qualified review remain necessary.'
        : '';
      return {
        answer: 'An important distinction: the priced recommendation currently shows ' + packageSummary + ', while the unresolved compliance point is ' + complianceHeading + ' ' + complianceSummary + mcaNote + ' D-Dey will need the vessel identity and flag, operation, actual voyage limits, maximum persons aboard, required MCA category when applicable, onboard medical qualifications, and any existing equipment before issuing a signed compliance document.' + disclaimer,
        suggestedQuestions: ['Why did the advisor choose this EMS base?', 'Which vessel details will D-Dey need for review?', 'How could the package be distributed across decks?'],
        escalationRequired: true
      };
    }

    return {
      answer: 'Based on the vessel profile, the current recommendation is ' + packageSummary + '. It reflects ' + people + ' people aboard a ' + length + ' vessel, ' + range.toLowerCase() + ', ' + duration.toLowerCase() + ', ' + storage.toLowerCase() + ', and the selected care-delay, training, deck, and auxiliary-craft factors. Ask about the EMS base, storage and tender distribution, or the remaining custom review, and I will explain that aspect of the recommendation.' + disclaimer,
      suggestedQuestions: suggestions,
      escalationRequired: false
    };
  }

  function askAdvisorConcierge(question) {
    var responseStatus = document.getElementById('DraAdvisorResponseStatus');
    var escalation = document.getElementById('DraAdvisorEscalation');
    var questionNode = document.getElementById('DraAdvisorQuestion');
    var cleanQuestion = String(question || '').replace(/\s+/g, ' ').trim().slice(0, 1000);
    if (!cleanQuestion || conciergeBusy) return;
    if (!advisorEndpointCandidates('concierge').length || !activeProfile || !activeBriefId) {
      if (responseStatus) responseStatus.textContent = 'Complete the vessel brief before asking the advisor.';
      return;
    }

    var priorHistory = conciergeHistory.slice(-6);
    addConciergeMessage('user', cleanQuestion);
    conciergeHistory.push({ role: 'user', text: cleanQuestion });
    if (questionNode) questionNode.value = '';
    if (escalation) escalation.hidden = true;
    renderConciergeSuggestions([]);
    setConciergeBusy(true);
    if (responseStatus) responseStatus.textContent = 'Checking your brief against the verified D-Dey package and current library status…';

    var controller = window.AbortController ? new AbortController() : null;
    var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, 26000);
    fetchAdvisorEndpoint('concierge', '', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        briefId: activeBriefId,
        company: '',
        question: cleanQuestion,
        profile: activeProfile,
        complianceSummary: activeCompliance,
        suggestedPackage: conciergePackagePayload(),
        history: priorHistory
      }),
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.message || 'The live concierge could not answer this question.');
        return data;
      });
    }).then(function (data) {
      var answer = data.concierge && data.concierge.answer;
      if (!answer) throw new Error('The live concierge returned an incomplete response.');
      addConciergeMessage('assistant', answer);
      conciergeHistory.push({ role: 'assistant', text: answer });
      conciergeHistory = conciergeHistory.slice(-6);
      renderConciergeSuggestions(data.concierge.suggestedQuestions || []);
      if (escalation) escalation.hidden = !data.concierge.escalationRequired;
      if (responseStatus) {
        var verifiedAt = data.grounding && data.grounding.catalogVerifiedAt ? new Date(data.grounding.catalogVerifiedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : 'this request';
        responseStatus.textContent = 'D-Dey catalog verified at ' + verifiedAt + '. Recommendation quantities were not changed.';
      }
    }).catch(function (error) {
      var guidance = conciergeFallbackGuidance(cleanQuestion, activeProfile, activeCompliance, conciergePackagePayload());
      addConciergeMessage('assistant', guidance.answer);
      conciergeHistory.push({ role: 'assistant', text: guidance.answer });
      conciergeHistory = conciergeHistory.slice(-6);
      renderConciergeSuggestions(guidance.suggestedQuestions || []);
      if (escalation) escalation.hidden = !guidance.escalationRequired;
      if (responseStatus) responseStatus.textContent = 'Guidance is based on your completed vessel brief and the recommendation shown above. Live catalog verification is temporarily unavailable.';
    }).finally(function () {
      window.clearTimeout(timeout);
      setConciergeBusy(false);
    });
  }

  function renderCardGrid(gridId, cards) {
    var grid = document.getElementById(gridId);
    grid.innerHTML = '';
    cards.forEach(function (card, index) {
      var article = document.createElement('article');
      article.className = 'dra__package-card' + (card.priority ? ' dra__package-card--priority' : '');
      addText(article, 'span', 'dra__package-card-number', card.label || String(index + 1).padStart(2, '0'));
      addText(article, 'h3', '', card.title);
      addText(article, 'p', '', card.text);
      var link = addText(article, 'a', '', card.action);
      link.href = card.link;
      link.appendChild(document.createTextNode(' →'));
      grid.appendChild(article);
    });
  }

  function formatMoney(cents) {
    var currency = root.dataset.currency || 'USD';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function packageTotalCents() {
    return activePackageItems.reduce(function (total, item) {
      return total + (item.priceCents * item.quantity);
    }, 0);
  }

  function packageSelectionKey() {
    return activePackageItems.map(function (item) {
      return item.key + '=' + item.quantity;
    }).join(';');
  }

  function packageReductionDetails() {
    var details = [];
    activePackageItems.forEach(function (item) {
      if (item.customRequired && item.quantity > 0) {
        details.push(item.title + ' requires a custom D-Dey order and cannot be completed as a standard online item');
      } else if (item.quantity < item.suggestedQuantity) {
        details.push(item.title + ' reduced to ' + item.quantity + ' from ' + item.suggestedQuantity);
      } else if (item.quantity > 0 && !item.variantId) {
        details.push(item.title + ' is not available as a standard online variant');
      }
    });
    return details;
  }

  function recommendationPlan() {
    return activePackageItems.map(function (item) {
      return item.key + '=' + item.suggestedQuantity + (item.customRequired || !item.variantId ? '!' : '');
    }).join(';');
  }

  function syncPackageAcknowledgement() {
    var panel = document.getElementById('DraReducedPackage');
    var checkbox = document.getElementById('DraReducedPackageAcknowledgement');
    var reason = document.getElementById('DraReducedPackageReason');
    if (!panel || !checkbox || !reason) return;

    var selectionKey = packageSelectionKey();
    if (activeWaiverSelectionKey !== selectionKey) checkbox.checked = false;
    activeWaiverSelectionKey = selectionKey;

    var details = packageReductionDetails();
    panel.hidden = details.length === 0;
    reason.textContent = details.length
      ? details.join('. ') + '.'
      : 'The selected quantities match or exceed the advisor recommendation.';
  }

  function fingerprint(value) {
    var source = typeof value === 'string' ? value : JSON.stringify(value);
    if (window.crypto && window.crypto.subtle && window.TextEncoder) {
      return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(source)).then(function (buffer) {
        return Array.prototype.map.call(new Uint8Array(buffer), function (byte) {
          return byte.toString(16).padStart(2, '0');
        }).join('');
      });
    }

    var hash = 2166136261;
    for (var i = 0; i < source.length; i += 1) {
      hash ^= source.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return Promise.resolve('fnv1a-' + (hash >>> 0).toString(16).padStart(8, '0'));
  }

  function numericVariantId(value) {
    var id = String(value || '').split('/').pop();
    return /^\d+$/.test(id) ? id : '';
  }

  function compactProfileAttributes(profile) {
    return {
      'D-Dey Vessel': labels.vesselType[profile.vesselType] + '; ' + profile.length + ' ' + profile.lengthUnit + '; ' + profile.decks + ' operational deck(s)',
      'D-Dey People Aboard': profile.passengers + ' passengers; ' + profile.crew + ' crew; ' + profile.total + ' total',
      'D-Dey Voyage Profile': labels.distance[String(profile.distance)] + '; ' + labels.duration[String(profile.duration)] + '; care ' + labels.careDelay[String(profile.careDelay)],
      'D-Dey Jurisdiction': profile.flagState + '; ' + labels.operatingWaters[profile.operatingWaters] + (profile.mcaCategory ? '; MCA ' + profile.mcaCategory : ''),
      'D-Dey Advisor Priority': labels.complianceIntent[profile.complianceIntent]
    };
  }

  function syncContactSummary() {
    var summaryField = document.getElementById('DraContactSummary');
    if (!summaryField || !activeContactOpening.length) return;

    var packageLines = activePackageItems.map(function (item) {
      var line = item.title + ' × ' + item.quantity;
      if (item.priceCents) line += ' — ' + formatMoney(item.priceCents * item.quantity);
      else line += ' — ' + (item.priceLabel || 'pricing requires review');
      if (item.customRequired) line += ' (required custom configuration for selected MCA Category A pathway)';
      if (item.quantity === 0) line += ' (removed by client)';
      return line;
    });
    var hasUnpriced = activePackageItems.some(function (item) {
      return item.quantity > 0 && !item.priceCents;
    });

    summaryField.value = activeContactOpening.concat([
      '',
      'Client-adjusted suggested package:',
      packageLines.join('\n'),
      'Estimated package total: ' + formatMoney(packageTotalCents()) + (hasUnpriced ? ' plus unpriced review items' : ''),
      'Estimate excludes taxes, shipping, prescriptions, training-format changes, custom modules, and compliance completion.'
    ], activeContactClosing).join('\n');
  }

  function updatePackageFigures() {
    activePackageItems.forEach(function (item, index) {
      var row = document.querySelector('[data-package-index="' + index + '"]');
      if (!row) return;
      row.classList.toggle('is-zero', item.quantity === 0);
      var count = row.querySelector('[data-package-count]');
      var minus = row.querySelector('[data-package-minus]');
      if (count) count.textContent = String(item.quantity);
      if (minus) minus.disabled = item.quantity === 0;
      row.querySelector('[data-line-subtotal]').textContent = item.priceCents
        ? formatMoney(item.priceCents * item.quantity)
        : (item.priceLabel || 'Price on review');
    });

    var total = packageTotalCents();
    var hasUnpriced = activePackageItems.some(function (item) {
      return item.quantity > 0 && !item.priceCents;
    });
    document.getElementById('DraPackageTotal').textContent = formatMoney(total);
    document.getElementById('DraPackageTotalNote').textContent = hasUnpriced
      ? 'One or more selected items require price confirmation and are excluded from this total.'
      : 'Estimated from the quantities shown above.';
    syncPackageAcknowledgement();
    syncContactSummary();
  }

  function renderSuggestedPackage(items) {
    activePackageItems = items;
    var lines = document.getElementById('DraPackageLines');
    lines.innerHTML = '';

    activePackageItems.forEach(function (item, index) {
      var row = document.createElement('article');
      row.className = 'dra__estimate-line' + (item.customRequired ? ' dra__estimate-line--required' : '');
      row.dataset.packageIndex = String(index);

      var identity = document.createElement('div');
      identity.className = 'dra__line-identity';
      var visual = document.createElement('div');
      visual.className = 'dra__line-visual';
      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title + ' product image';
        image.width = 112;
        image.height = 112;
        image.loading = 'lazy';
        image.decoding = 'async';
        visual.appendChild(image);
      } else {
        addText(visual, 'span', '', item.customRequired ? 'RX / A' : 'D-DEY');
      }
      identity.appendChild(visual);

      var copy = document.createElement('div');
      addText(copy, 'span', 'dra__line-category', item.category);
      var title = document.createElement('h3');
      var titleLink = addText(title, 'a', '', item.title);
      titleLink.href = item.url;
      copy.appendChild(title);
      addText(copy, 'p', '', item.rationale);
      var productLink = addText(copy, 'a', 'dra__line-link', item.linkLabel || 'View system →');
      productLink.href = item.url;
      identity.appendChild(copy);
      row.appendChild(identity);

      var unit = document.createElement('div');
      unit.className = 'dra__line-money dra__line-unit';
      addText(unit, 'span', '', 'Unit price');
      addText(unit, 'strong', '', item.priceCents ? formatMoney(item.priceCents) : (item.priceLabel || 'Price on review'));
      row.appendChild(unit);

      var quantity = document.createElement('div');
      quantity.className = 'dra__line-quantity';
      if (item.fixedQuantity) {
        addText(quantity, 'span', 'dra__suggested-quantity', 'Required custom build');
        addText(quantity, 'strong', 'dra__required-quantity', '1 vessel-specific chest');
      } else {
        addText(quantity, 'span', 'dra__suggested-quantity', 'Suggested: ' + item.suggestedQuantity);
        var controls = document.createElement('div');
        controls.className = 'dra__quantity-controls';
        var minus = addText(controls, 'button', '', '−');
        minus.type = 'button';
        minus.dataset.packageMinus = '';
        minus.dataset.packageDelta = '-1';
        minus.setAttribute('aria-label', 'Remove one ' + item.title);
        var count = addText(controls, 'span', '', String(item.quantity));
        count.dataset.packageCount = '';
        count.setAttribute('aria-live', 'polite');
        var plus = addText(controls, 'button', '', '+');
        plus.type = 'button';
        plus.dataset.packageDelta = '1';
        plus.setAttribute('aria-label', 'Add one ' + item.title);
        quantity.appendChild(controls);
      }
      row.appendChild(quantity);

      var subtotal = document.createElement('div');
      subtotal.className = 'dra__line-money dra__line-subtotal';
      addText(subtotal, 'span', '', 'Estimated subtotal');
      var subtotalValue = addText(subtotal, 'strong', '', item.priceCents ? formatMoney(item.priceCents * item.quantity) : (item.priceLabel || 'Price on review'));
      subtotalValue.dataset.lineSubtotal = '';
      row.appendChild(subtotal);

      lines.appendChild(row);
    });

    updatePackageFigures();
  }

  function renderRecommendation(profile) {
    var recommendation = chooseKit(profile);
    var kit = recommendation.product;
    var guardian = chooseGuardian(profile);
    var compliance = complianceFor(profile);
    var suggestedPackage = suggestedPackageFor(profile, recommendation, guardian, compliance);
    var packageCards = packageFor(profile, recommendation, compliance, guardian);
    var briefSuffix = window.crypto && window.crypto.getRandomValues
      ? Array.prototype.map.call(window.crypto.getRandomValues(new Uint8Array(3)), function (value) { return value.toString(16).padStart(2, '0'); }).join('').toUpperCase()
      : String(Date.now()).slice(-6);
    var briefId = 'DDEY—' + new Date().toISOString().slice(0, 10).replace(/-/g, '') + '—' + String(profile.total).padStart(2, '0') + '—' + briefSuffix;
    activeBriefId = briefId;
    activeProfile = profile;
    activeCompliance = compliance;

    document.getElementById('DraBriefId').textContent = briefId;

    var reasonList = document.getElementById('DraReasonList');
    reasonList.innerHTML = '';
    recommendation.reasons.forEach(function (reason) { addText(reasonList, 'div', 'dra__reason', reason); });

    var brief = [
      ['Operation', labels.operation[profile.operation]],
      ['Flag state', profile.flagState],
      ...(profile.flag === 'uk' ? [['MCA category', labels.mcaCategory[profile.mcaCategory] || 'D-Dey determination required']] : []),
      ['Vessel', labels.vesselType[profile.vesselType]],
      ['Length', profile.length + ' ' + profile.lengthUnit],
      ['Operational decks', String(profile.decks)],
      ['Storage', labels.storage[profile.storage]],
      ['Kit mobility', labels.kitTransfer[profile.kitTransfer]],
      ['Auxiliary craft away at once', String(profile.auxiliaryCraft)],
      ['People away on auxiliary craft', String(profile.auxiliaryPeople)],
      ['Planning priority', labels.complianceIntent[profile.complianceIntent]],
      ['Range', labels.distance[String(profile.distance)]],
      ['Expected time to care', labels.careDelay[String(profile.careDelay)]],
      ['People aboard', String(profile.total)]
    ];
    var briefGrid = document.getElementById('DraBriefGrid');
    briefGrid.innerHTML = '';
    brief.forEach(function (item) {
      var cell = document.createElement('div');
      cell.className = 'dra__brief-item';
      addText(cell, 'span', '', item[0]);
      addText(cell, 'strong', '', item[1]);
      briefGrid.appendChild(cell);
    });

    renderSuggestedPackage(suggestedPackage);
    resetAdvisorConcierge();
    document.getElementById('DraCustomMedicationNotice').hidden = !suggestedPackage.some(function (item) { return item.customRequired; });
    renderCardGrid('DraPackageGrid', packageCards);

    document.getElementById('DraComplianceStatus').textContent = compliance.status;
    document.getElementById('DraComplianceLabel').textContent = compliance.label;
    document.getElementById('DraComplianceHeading').textContent = compliance.heading;
    document.getElementById('DraComplianceSummary').textContent = compliance.summary;
    var actionList = document.getElementById('DraComplianceActions');
    actionList.innerHTML = '';
    compliance.actions.forEach(function (action) { addText(actionList, 'li', '', action); });

    var riskText = profile.risks.length ? profile.risks.join(', ') : 'None selected';
    activeContactOpening = [
      'D-DEY Vessel Medical Readiness Advisor brief',
      'Brief: ' + briefId,
      'Reviewed against source set dated: ' + root.dataset.reviewedDate,
      '',
      'Operation: ' + labels.operation[profile.operation],
      'Flag state: ' + profile.flagState,
      ...(profile.flag === 'uk' ? ['Required MCA medical-stores category: ' + (labels.mcaCategory[profile.mcaCategory] || 'D-Dey determination required')] : []),
      'Primary operating waters: ' + labels.operatingWaters[profile.operatingWaters],
      'Vessel: ' + labels.vesselType[profile.vesselType],
      'Length: ' + profile.length + ' ' + profile.lengthUnit,
      'Operational decks / levels: ' + profile.decks,
      'Medical-kit storage preference: ' + labels.storage[profile.storage],
      'Medical-kit mobility: ' + labels.kitTransfer[profile.kitTransfer],
      'Maximum auxiliary craft away at once: ' + profile.auxiliaryCraft,
      'Maximum people away on auxiliary craft: ' + profile.auxiliaryPeople,
      'Recommendation priority: ' + labels.complianceIntent[profile.complianceIntent],
      'Accommodation: ' + (profile.accommodation === 'yes' ? 'Cabin accommodation' : 'No overnight cabin'),
      'Maximum range: ' + labels.distance[String(profile.distance)],
      'Maximum duration: ' + labels.duration[String(profile.duration)],
      'Expected time to professional medical care: ' + labels.careDelay[String(profile.careDelay)],
      'Passengers/guests: ' + profile.passengers,
      'Crew: ' + profile.crew,
      'Training: ' + labels.training[profile.training],
      'Operating factors: ' + riskText,
      'Inventory-verified EMS base recommendation: ' + kit.title
    ];
    activeContactClosing = [
      '',
      'Survival authority context: ' + (guardian ? guardian.authority.label : profile.flagState + ' flag-state review'),
      'Regulatory read: ' + compliance.label + ' — ' + compliance.status,
      '',
      'Client acknowledged that this planning tool does not guarantee compliance.'
    ];
    syncContactSummary();

    results.hidden = false;
    results.focus({ preventScroll: true });
    results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }

  document.getElementById('DraPackageLines').addEventListener('click', function (event) {
    var button = event.target.closest('[data-package-delta]');
    if (!button) return;
    var row = button.closest('[data-package-index]');
    var index = row ? Number(row.dataset.packageIndex) : -1;
    var item = activePackageItems[index];
    if (!item) return;
    item.quantity = Math.max(0, Math.min(99, item.quantity + Number(button.dataset.packageDelta)));
    updatePackageFigures();
  });

  document.getElementById('DraResetPackage').addEventListener('click', function () {
    activePackageItems.forEach(function (item) {
      item.quantity = item.suggestedQuantity;
    });
    updatePackageFigures();
  });

  document.getElementById('DraAddPackageToCart').addEventListener('click', function () {
    var button = document.getElementById('DraAddPackageToCart');
    var cartStatus = document.getElementById('DraCartStatus');
    var acknowledgement = document.getElementById('DraReducedPackageAcknowledgement');
    var reductionDetails = packageReductionDetails();
    var acknowledgementRequired = reductionDetails.length > 0;
    if (!activeProfile || !activeBriefId) return;

    if (acknowledgementRequired && (!acknowledgement || !acknowledgement.checked)) {
      cartStatus.textContent = 'Please check the reduced-configuration acknowledgement before continuing to cart.';
      if (acknowledgement) acknowledgement.focus();
      return;
    }

    var purchasableItems = activePackageItems.filter(function (item) {
      return item.quantity > 0 && !item.customRequired && numericVariantId(item.variantId);
    });
    if (!purchasableItems.length) {
      cartStatus.textContent = 'No standard online products remain selected. Request a custom D-Dey review to continue.';
      return;
    }

    button.disabled = true;
    button.textContent = 'Preparing your vessel package…';
    cartStatus.textContent = 'Recording the recommendation and selected configuration with your cart…';

    var acceptedAt = acknowledgementRequired ? new Date().toISOString() : '';
    var recommendedPlan = recommendationPlan();
    var selectedPlan = activePackageItems.map(function (item) {
      var purchasable = item.quantity > 0 && !item.customRequired && numericVariantId(item.variantId);
      return item.key + '=' + (purchasable ? item.quantity : 0);
    }).join(';');
    var regulatoryRecord = activeProfile.regulatoryState || {
      reviewedDate: root.dataset.reviewedDate,
      flagState: activeProfile.flagState,
      status: 'custom_review_required'
    };

    Promise.all([
      fingerprint(activeProfile),
      fingerprint(activeBriefId + '|' + recommendedPlan),
      fingerprint(activeBriefId + '|' + selectedPlan),
      fingerprint(regulatoryRecord)
    ]).then(function (hashes) {
      var profileFingerprint = hashes[0];
      var recommendationFingerprint = hashes[1];
      var selectionFingerprint = hashes[2];
      var regulatoryFingerprint = hashes[3];
      var items = purchasableItems.map(function (item) {
        return {
          id: numericVariantId(item.variantId),
          quantity: item.quantity,
          properties: {
            '_DDEY Advisor Brief': activeBriefId,
            '_DDEY Advisor Line Key': item.key,
            '_DDEY Advisor Role': item.category,
            '_DDEY Recommended Quantity': String(item.suggestedQuantity),
            '_DDEY Recommendation Plan': recommendedPlan,
            '_DDEY Profile Fingerprint': profileFingerprint,
            '_DDEY Recommendation Fingerprint': recommendationFingerprint,
            '_DDEY Regulatory Fingerprint': regulatoryFingerprint,
            '_DDEY Disclaimer Required': acknowledgementRequired ? 'Yes' : 'No',
            '_DDEY Disclaimer Version': DISCLAIMER_VERSION,
            '_DDEY Disclaimer Accepted At': acceptedAt,
            '_DDEY Disclaimer Selection Fingerprint': selectionFingerprint
          }
        };
      });

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Shopify could not add the selected products.'); });
        return response.json();
      }).then(function () {
        var attributes = Object.assign({
          'D-Dey Advisor Brief ID': activeBriefId,
          'D-Dey Vessel Profile Fingerprint': profileFingerprint,
          'D-Dey Recommendation Fingerprint': recommendationFingerprint,
          'D-Dey Selected Package Fingerprint': selectionFingerprint,
          'D-Dey Regulatory Source Fingerprint': regulatoryFingerprint,
          'D-Dey Recommendation Plan': recommendedPlan,
          'D-Dey Selected Plan': selectedPlan,
          'D-Dey Compliance Selection': acknowledgementRequired ? 'Reduced configuration' : 'Advisor recommendation',
          'D-Dey Reduced/Omitted Items': reductionDetails.join('; ').slice(0, 250),
          'D-Dey Disclaimer Required': acknowledgementRequired ? 'Yes' : 'No',
          'D-Dey Disclaimer Accepted': acknowledgementRequired ? 'Yes' : 'Not required',
          'D-Dey Disclaimer Version': DISCLAIMER_VERSION,
          'D-Dey Disclaimer Accepted At': acceptedAt,
          'D-Dey Disclaimer Selection Fingerprint': selectionFingerprint,
          'D-Dey Disclaimer Text': acknowledgementRequired ? DISCLAIMER_TEXT : ''
        }, compactProfileAttributes(activeProfile));

        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('Shopify could not attach the advisor record to the cart.');
        window.location.assign('/cart');
      });
    }).catch(function (error) {
      button.disabled = false;
      button.innerHTML = 'Add selected package to cart <span aria-hidden="true">→</span>';
      cartStatus.textContent = error && error.message
        ? error.message + ' Please try again or request a custom review.'
        : 'The selected package could not be added. Please try again or request a custom review.';
    });
  });

  nextButton.addEventListener('click', function () {
    if (!validateStep()) return;
    if (currentStep < steps.length - 1) {
      setStep(currentStep + 1);
      root.querySelector('.dra__builder-frame').scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      var profile = collectProfile();
      if (profile.total < 1) {
        status.textContent = 'Please enter at least one passenger or crew member.';
        form.elements.passengers.focus();
        return;
      }
      nextButton.disabled = true;
      status.textContent = 'Checking the latest official flag-state sources…';
      loadRegulatoryState(profile).then(function (regulatoryState) {
        profile.regulatoryState = regulatoryState;
        renderRecommendation(profile);
        status.textContent = regulatoryState.status === 'current'
          ? 'Official sources checked. Your recommendation is ready.'
          : 'Your recommendation is ready with the current regulatory review status shown below.';
      }).finally(function () {
        nextButton.disabled = false;
      });
    }
  });

  backButton.addEventListener('click', function () { setStep(currentStep - 1); });
  progress.forEach(function (item) {
    item.addEventListener('click', function () {
      var target = Number(item.dataset.progressStep);
      if (target <= currentStep) setStep(target);
    });
  });
  var flagStateInput = form.elements.flagState;
  if (flagStateInput) {
    flagStateInput.addEventListener('input', syncMcaCategoryField);
    flagStateInput.addEventListener('change', syncMcaCategoryField);
  }
  document.getElementById('DraEdit').addEventListener('click', function () {
    root.querySelector('.dra__builder').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var advisorQuestionForm = document.getElementById('DraAdvisorQuestionForm');
  if (advisorQuestionForm) {
    advisorQuestionForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var question = document.getElementById('DraAdvisorQuestion');
      askAdvisorConcierge(question ? question.value : '');
    });
  }
  var advisorSuggestions = document.getElementById('DraAdvisorSuggestions');
  if (advisorSuggestions) {
    advisorSuggestions.addEventListener('click', function (event) {
      var button = event.target.closest('[data-concierge-question]');
      if (button) askAdvisorConcierge(button.dataset.conciergeQuestion);
    });
  }

  if (contactForm) {
    contactForm.addEventListener('submit', function (event) {
      if (!advisorEndpointCandidates('compliance').length || !activeProfile || !activeBriefId || contactForm.dataset.complianceRecorded === 'true') return;

      event.preventDefault();
      var submitButton = contactForm.querySelector('button[type="submit"]');
      var submitStatus = document.getElementById('DraConsultationStatus');
      var nameField = contactForm.querySelector('[name="contact[name]"]');
      var emailField = contactForm.querySelector('[name="contact[email]"]');
      var phoneField = contactForm.querySelector('[name="contact[phone]"]');
      var vesselField = contactForm.querySelector('[name="contact[vessel_name]"]');
      var summaryField = document.getElementById('DraContactSummary');
      var originalButtonText = submitButton ? submitButton.innerHTML : '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Preparing your private review…';
      }
      if (submitStatus) submitStatus.textContent = 'Creating your confidential D-Dey consultation record…';

      var payload = {
        briefId: activeBriefId,
        reviewedDate: root.dataset.reviewedDate,
        company: '',
        client: {
          name: nameField ? nameField.value : '',
          email: emailField ? emailField.value : '',
          phone: phoneField ? phoneField.value : '',
          vesselName: vesselField ? vesselField.value : ''
        },
        profile: activeProfile,
        complianceSummary: activeCompliance,
        checkoutAcknowledgement: {
          required: packageReductionDetails().length > 0,
          accepted: Boolean(document.getElementById('DraReducedPackageAcknowledgement') && document.getElementById('DraReducedPackageAcknowledgement').checked),
          version: DISCLAIMER_VERSION,
          selectedPlan: packageSelectionKey(),
          recommendationPlan: recommendationPlan()
        },
        suggestedPackage: activePackageItems.map(function (item) {
          return {
            role: item.category,
            title: item.title,
            quantity: item.quantity,
            variantId: item.variantId || '',
            productUrl: item.url || '',
            priceCents: item.priceCents || 0
          };
        })
      };

      var controller = window.AbortController ? new AbortController() : null;
      var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, 9000);
      fetchAdvisorEndpoint('compliance', '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('Consultation record endpoint returned ' + response.status + '.');
        return response.json();
      }).then(function (data) {
        contactForm.dataset.complianceRecorded = 'true';
        if (summaryField && data.consultation && data.consultation.id) {
          summaryField.value += '\nPrivate admin consultation record: ' + data.consultation.id;
        }
        if (submitStatus) submitStatus.textContent = 'Your private review record is ready. Sending the request to D-Dey…';
      }).catch(function () {
        contactForm.dataset.complianceRecorded = 'fallback-email';
        if (summaryField) summaryField.value += '\nAdmin record note: automatic compliance workspace creation was unavailable; create the record from this email brief.';
        if (submitStatus) submitStatus.textContent = 'Sending your vessel brief directly to D-Dey…';
      }).finally(function () {
        window.clearTimeout(timeout);
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerHTML = originalButtonText;
        }
        contactForm.submit();
      });
    });
  }
  syncMcaCategoryField();
  setStep(0);
})();
